
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
const $fcf02a95a4622ee8$var$EPSILON = 0.000001;
function $fcf02a95a4622ee8$export$f24224f1c91d8156(a) {
    let x = a[0];
    let y = a[1];
    let z = a[2];
    return Math.sqrt(x * x + y * y + z * z);
}
function $fcf02a95a4622ee8$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $fcf02a95a4622ee8$export$adaa4cf7ef1b65be(out, x, y, z) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $fcf02a95a4622ee8$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    return out;
}
function $fcf02a95a4622ee8$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    return out;
}
function $fcf02a95a4622ee8$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    return out;
}
function $fcf02a95a4622ee8$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    return out;
}
function $fcf02a95a4622ee8$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    return out;
}
function $fcf02a95a4622ee8$export$9f17032d917177de(a, b) {
    let x = b[0] - a[0];
    let y = b[1] - a[1];
    let z = b[2] - a[2];
    return Math.sqrt(x * x + y * y + z * z);
}
function $fcf02a95a4622ee8$export$88e6ebb4fe54f538(a, b) {
    let x = b[0] - a[0];
    let y = b[1] - a[1];
    let z = b[2] - a[2];
    return x * x + y * y + z * z;
}
function $fcf02a95a4622ee8$export$ab44e1323ffc8376(a) {
    let x = a[0];
    let y = a[1];
    let z = a[2];
    return x * x + y * y + z * z;
}
function $fcf02a95a4622ee8$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    return out;
}
function $fcf02a95a4622ee8$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    return out;
}
function $fcf02a95a4622ee8$export$a3295358bff77e(out, a) {
    let x = a[0];
    let y = a[1];
    let z = a[2];
    let len = x * x + y * y + z * z;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    out[2] = a[2] * len;
    return out;
}
function $fcf02a95a4622ee8$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $fcf02a95a4622ee8$export$bb646b20bb93d339(out, a, b) {
    let ax = a[0], ay = a[1], az = a[2];
    let bx = b[0], by = b[1], bz = b[2];
    out[0] = ay * bz - az * by;
    out[1] = az * bx - ax * bz;
    out[2] = ax * by - ay * bx;
    return out;
}
function $fcf02a95a4622ee8$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    let ax = a[0];
    let ay = a[1];
    let az = a[2];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    return out;
}
function $fcf02a95a4622ee8$export$5ffbd13800309d59(out, a, m) {
    let x = a[0], y = a[1], z = a[2];
    let w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
    return out;
}
function $fcf02a95a4622ee8$export$58ce737ad0c12bc2(out, a, m) {
    let x = a[0], y = a[1], z = a[2];
    let w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z) / w;
    return out;
}
function $fcf02a95a4622ee8$export$f0bfa0a0024626ee(out, a, m) {
    let x = a[0], y = a[1], z = a[2];
    out[0] = x * m[0] + y * m[3] + z * m[6];
    out[1] = x * m[1] + y * m[4] + z * m[7];
    out[2] = x * m[2] + y * m[5] + z * m[8];
    return out;
}
function $fcf02a95a4622ee8$export$c32adef9e939ce85(out, a, q) {
    // benchmarks: https://jsperf.com/quaternion-transform-vec3-implementations-fixed
    let x = a[0], y = a[1], z = a[2];
    let qx = q[0], qy = q[1], qz = q[2], qw = q[3];
    let uvx = qy * z - qz * y;
    let uvy = qz * x - qx * z;
    let uvz = qx * y - qy * x;
    let uuvx = qy * uvz - qz * uvy;
    let uuvy = qz * uvx - qx * uvz;
    let uuvz = qx * uvy - qy * uvx;
    let w2 = qw * 2;
    uvx *= w2;
    uvy *= w2;
    uvz *= w2;
    uuvx *= 2;
    uuvy *= 2;
    uuvz *= 2;
    out[0] = x + uvx + uuvx;
    out[1] = y + uvy + uuvy;
    out[2] = z + uvz + uuvz;
    return out;
}
const $fcf02a95a4622ee8$export$944b09d2ad10b378 = function() {
    const tempA = [
        0,
        0,
        0
    ];
    const tempB = [
        0,
        0,
        0
    ];
    return function(a, b) {
        $fcf02a95a4622ee8$export$784d13d8ee351f07(tempA, a);
        $fcf02a95a4622ee8$export$784d13d8ee351f07(tempB, b);
        $fcf02a95a4622ee8$export$a3295358bff77e(tempA, tempA);
        $fcf02a95a4622ee8$export$a3295358bff77e(tempB, tempB);
        let cosine = $fcf02a95a4622ee8$export$94132a0e348806d4(tempA, tempB);
        if (cosine > 1.0) return 0;
        else if (cosine < -1) return Math.PI;
        else return Math.acos(cosine);
    };
}();
function $fcf02a95a4622ee8$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}


class $46d76f993ed555f5$export$838423f3adec30fa extends Array {
    constructor(x = 0, y = x, z = x){
        super(x, y, z);
        return this;
    }
    get x() {
        return this[0];
    }
    get y() {
        return this[1];
    }
    get z() {
        return this[2];
    }
    set x(v) {
        this[0] = v;
    }
    set y(v) {
        this[1] = v;
    }
    set z(v) {
        this[2] = v;
    }
    set(x, y = x, z = x) {
        if (x.length) return this.copy(x);
        $fcf02a95a4622ee8$export$adaa4cf7ef1b65be(this, x, y, z);
        return this;
    }
    copy(v) {
        $fcf02a95a4622ee8$export$784d13d8ee351f07(this, v);
        return this;
    }
    add(va, vb) {
        if (vb) $fcf02a95a4622ee8$export$e16d8520af44a096(this, va, vb);
        else $fcf02a95a4622ee8$export$e16d8520af44a096(this, this, va);
        return this;
    }
    sub(va, vb) {
        if (vb) $fcf02a95a4622ee8$export$4e2d2ead65e5f7e3(this, va, vb);
        else $fcf02a95a4622ee8$export$4e2d2ead65e5f7e3(this, this, va);
        return this;
    }
    multiply(v) {
        if (v.length) $fcf02a95a4622ee8$export$2060d2db72cce88f(this, this, v);
        else $fcf02a95a4622ee8$export$dcdf75081b88279d(this, this, v);
        return this;
    }
    divide(v) {
        if (v.length) $fcf02a95a4622ee8$export$cd007d971a5a2143(this, this, v);
        else $fcf02a95a4622ee8$export$dcdf75081b88279d(this, this, 1 / v);
        return this;
    }
    inverse(v = this) {
        $fcf02a95a4622ee8$export$70ae2c07e401031b(this, v);
        return this;
    }
    // Can't use 'length' as Array.prototype uses it
    len() {
        return $fcf02a95a4622ee8$export$f24224f1c91d8156(this);
    }
    distance(v) {
        if (v) return $fcf02a95a4622ee8$export$9f17032d917177de(this, v);
        else return $fcf02a95a4622ee8$export$f24224f1c91d8156(this);
    }
    squaredLen() {
        return $fcf02a95a4622ee8$export$ab44e1323ffc8376(this);
    }
    squaredDistance(v) {
        if (v) return $fcf02a95a4622ee8$export$88e6ebb4fe54f538(this, v);
        else return $fcf02a95a4622ee8$export$ab44e1323ffc8376(this);
    }
    negate(v = this) {
        $fcf02a95a4622ee8$export$aef51622e549b8b0(this, v);
        return this;
    }
    cross(va, vb) {
        if (vb) $fcf02a95a4622ee8$export$bb646b20bb93d339(this, va, vb);
        else $fcf02a95a4622ee8$export$bb646b20bb93d339(this, this, va);
        return this;
    }
    scale(v) {
        $fcf02a95a4622ee8$export$dcdf75081b88279d(this, this, v);
        return this;
    }
    normalize() {
        $fcf02a95a4622ee8$export$a3295358bff77e(this, this);
        return this;
    }
    dot(v) {
        return $fcf02a95a4622ee8$export$94132a0e348806d4(this, v);
    }
    equals(v) {
        return $fcf02a95a4622ee8$export$f2599a5cf1109d8(this, v);
    }
    applyMatrix3(mat3) {
        $fcf02a95a4622ee8$export$f0bfa0a0024626ee(this, this, mat3);
        return this;
    }
    applyMatrix4(mat4) {
        $fcf02a95a4622ee8$export$5ffbd13800309d59(this, this, mat4);
        return this;
    }
    scaleRotateMatrix4(mat4) {
        $fcf02a95a4622ee8$export$58ce737ad0c12bc2(this, this, mat4);
        return this;
    }
    applyQuaternion(q) {
        $fcf02a95a4622ee8$export$c32adef9e939ce85(this, this, q);
        return this;
    }
    angle(v) {
        return $fcf02a95a4622ee8$export$944b09d2ad10b378(this, v);
    }
    lerp(v, t) {
        $fcf02a95a4622ee8$export$3a89f8d6f6bf6c9f(this, this, v, t);
        return this;
    }
    clone() {
        return new $46d76f993ed555f5$export$838423f3adec30fa(this[0], this[1], this[2]);
    }
    fromArray(a, o = 0) {
        this[0] = a[o];
        this[1] = a[o + 1];
        this[2] = a[o + 2];
        return this;
    }
    toArray(a = [], o = 0) {
        a[o] = this[0];
        a[o + 1] = this[1];
        a[o + 2] = this[2];
        return a;
    }
    transformDirection(mat4) {
        const x = this[0];
        const y = this[1];
        const z = this[2];
        this[0] = mat4[0] * x + mat4[4] * y + mat4[8] * z;
        this[1] = mat4[1] * x + mat4[5] * y + mat4[9] * z;
        this[2] = mat4[2] * x + mat4[6] * y + mat4[10] * z;
        return this.normalize();
    }
}


const $2142ba2b61102ce6$var$EPSILON = 0.000001;
function $2142ba2b61102ce6$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $2142ba2b61102ce6$export$adaa4cf7ef1b65be(out, x, y, z, w) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function $2142ba2b61102ce6$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    return out;
}
function $2142ba2b61102ce6$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    return out;
}
function $2142ba2b61102ce6$export$f24224f1c91d8156(a) {
    let x = a[0];
    let y = a[1];
    let z = a[2];
    let w = a[3];
    return Math.sqrt(x * x + y * y + z * z + w * w);
}
function $2142ba2b61102ce6$export$a3295358bff77e(out, a) {
    let x = a[0];
    let y = a[1];
    let z = a[2];
    let w = a[3];
    let len = x * x + y * y + z * z + w * w;
    if (len > 0) len = 1 / Math.sqrt(len);
    out[0] = x * len;
    out[1] = y * len;
    out[2] = z * len;
    out[3] = w * len;
    return out;
}
function $2142ba2b61102ce6$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
}
function $2142ba2b61102ce6$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    let ax = a[0];
    let ay = a[1];
    let az = a[2];
    let aw = a[3];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    out[3] = aw + t * (b[3] - aw);
    return out;
}


function $0b0b47b0a5724ccd$export$f0954fd7d5368655(out) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    return out;
}
function $0b0b47b0a5724ccd$export$4286ddefc8f49512(out, axis, rad) {
    rad = rad * 0.5;
    let s = Math.sin(rad);
    out[0] = s * axis[0];
    out[1] = s * axis[1];
    out[2] = s * axis[2];
    out[3] = Math.cos(rad);
    return out;
}
function $0b0b47b0a5724ccd$export$2060d2db72cce88f(out, a, b) {
    let ax = a[0], ay = a[1], az = a[2], aw = a[3];
    let bx = b[0], by = b[1], bz = b[2], bw = b[3];
    out[0] = ax * bw + aw * bx + ay * bz - az * by;
    out[1] = ay * bw + aw * by + az * bx - ax * bz;
    out[2] = az * bw + aw * bz + ax * by - ay * bx;
    out[3] = aw * bw - ax * bx - ay * by - az * bz;
    return out;
}
function $0b0b47b0a5724ccd$export$a59c8716592e09af(out, a, rad) {
    rad *= 0.5;
    let ax = a[0], ay = a[1], az = a[2], aw = a[3];
    let bx = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw + aw * bx;
    out[1] = ay * bw + az * bx;
    out[2] = az * bw - ay * bx;
    out[3] = aw * bw - ax * bx;
    return out;
}
function $0b0b47b0a5724ccd$export$cf71e4d4ca4d1cfd(out, a, rad) {
    rad *= 0.5;
    let ax = a[0], ay = a[1], az = a[2], aw = a[3];
    let by = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw - az * by;
    out[1] = ay * bw + aw * by;
    out[2] = az * bw + ax * by;
    out[3] = aw * bw - ay * by;
    return out;
}
function $0b0b47b0a5724ccd$export$ea6eae3365de5b9c(out, a, rad) {
    rad *= 0.5;
    let ax = a[0], ay = a[1], az = a[2], aw = a[3];
    let bz = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw + ay * bz;
    out[1] = ay * bw - ax * bz;
    out[2] = az * bw + aw * bz;
    out[3] = aw * bw - az * bz;
    return out;
}
function $0b0b47b0a5724ccd$export$1544d9bc2995de08(out, a, b, t) {
    // benchmarks:
    //    http://jsperf.com/quaternion-slerp-implementations
    let ax = a[0], ay = a[1], az = a[2], aw = a[3];
    let bx = b[0], by = b[1], bz = b[2], bw = b[3];
    let omega, cosom, sinom, scale0, scale1;
    // calc cosine
    cosom = ax * bx + ay * by + az * bz + aw * bw;
    // adjust signs (if necessary)
    if (cosom < 0.0) {
        cosom = -cosom;
        bx = -bx;
        by = -by;
        bz = -bz;
        bw = -bw;
    }
    // calculate coefficients
    if (1.0 - cosom > 0.000001) {
        // standard case (slerp)
        omega = Math.acos(cosom);
        sinom = Math.sin(omega);
        scale0 = Math.sin((1.0 - t) * omega) / sinom;
        scale1 = Math.sin(t * omega) / sinom;
    } else {
        // "from" and "to" quaternions are very close
        //  ... so we can do a linear interpolation
        scale0 = 1.0 - t;
        scale1 = t;
    }
    // calculate final values
    out[0] = scale0 * ax + scale1 * bx;
    out[1] = scale0 * ay + scale1 * by;
    out[2] = scale0 * az + scale1 * bz;
    out[3] = scale0 * aw + scale1 * bw;
    return out;
}
function $0b0b47b0a5724ccd$export$6897c284b6f9f4dc(out, a) {
    let a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    let dot = a0 * a0 + a1 * a1 + a2 * a2 + a3 * a3;
    let invDot = dot ? 1.0 / dot : 0;
    // TODO: Would be faster to return [0,0,0,0] immediately if dot == 0
    out[0] = -a0 * invDot;
    out[1] = -a1 * invDot;
    out[2] = -a2 * invDot;
    out[3] = a3 * invDot;
    return out;
}
function $0b0b47b0a5724ccd$export$7679f47e72c62560(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = a[3];
    return out;
}
function $0b0b47b0a5724ccd$export$272a1eb8e5a4b55b(out, m) {
    // Algorithm in Ken Shoemake's article in 1987 SIGGRAPH course notes
    // article "Quaternion Calculus and Fast Animation".
    let fTrace = m[0] + m[4] + m[8];
    let fRoot;
    if (fTrace > 0.0) {
        // |w| > 1/2, may as well choose w > 1/2
        fRoot = Math.sqrt(fTrace + 1.0); // 2w
        out[3] = 0.5 * fRoot;
        fRoot = 0.5 / fRoot; // 1/(4w)
        out[0] = (m[5] - m[7]) * fRoot;
        out[1] = (m[6] - m[2]) * fRoot;
        out[2] = (m[1] - m[3]) * fRoot;
    } else {
        // |w| <= 1/2
        let i = 0;
        if (m[4] > m[0]) i = 1;
        if (m[8] > m[i * 3 + i]) i = 2;
        let j = (i + 1) % 3;
        let k = (i + 2) % 3;
        fRoot = Math.sqrt(m[i * 3 + i] - m[j * 3 + j] - m[k * 3 + k] + 1.0);
        out[i] = 0.5 * fRoot;
        fRoot = 0.5 / fRoot;
        out[3] = (m[j * 3 + k] - m[k * 3 + j]) * fRoot;
        out[j] = (m[j * 3 + i] + m[i * 3 + j]) * fRoot;
        out[k] = (m[k * 3 + i] + m[i * 3 + k]) * fRoot;
    }
    return out;
}
function $0b0b47b0a5724ccd$export$7a404a587ea85af(out, euler, order = "YXZ") {
    let sx = Math.sin(euler[0] * 0.5);
    let cx = Math.cos(euler[0] * 0.5);
    let sy = Math.sin(euler[1] * 0.5);
    let cy = Math.cos(euler[1] * 0.5);
    let sz = Math.sin(euler[2] * 0.5);
    let cz = Math.cos(euler[2] * 0.5);
    if (order === "XYZ") {
        out[0] = sx * cy * cz + cx * sy * sz;
        out[1] = cx * sy * cz - sx * cy * sz;
        out[2] = cx * cy * sz + sx * sy * cz;
        out[3] = cx * cy * cz - sx * sy * sz;
    } else if (order === "YXZ") {
        out[0] = sx * cy * cz + cx * sy * sz;
        out[1] = cx * sy * cz - sx * cy * sz;
        out[2] = cx * cy * sz - sx * sy * cz;
        out[3] = cx * cy * cz + sx * sy * sz;
    } else if (order === "ZXY") {
        out[0] = sx * cy * cz - cx * sy * sz;
        out[1] = cx * sy * cz + sx * cy * sz;
        out[2] = cx * cy * sz + sx * sy * cz;
        out[3] = cx * cy * cz - sx * sy * sz;
    } else if (order === "ZYX") {
        out[0] = sx * cy * cz - cx * sy * sz;
        out[1] = cx * sy * cz + sx * cy * sz;
        out[2] = cx * cy * sz - sx * sy * cz;
        out[3] = cx * cy * cz + sx * sy * sz;
    } else if (order === "YZX") {
        out[0] = sx * cy * cz + cx * sy * sz;
        out[1] = cx * sy * cz + sx * cy * sz;
        out[2] = cx * cy * sz - sx * sy * cz;
        out[3] = cx * cy * cz - sx * sy * sz;
    } else if (order === "XZY") {
        out[0] = sx * cy * cz - cx * sy * sz;
        out[1] = cx * sy * cz - sx * cy * sz;
        out[2] = cx * cy * sz + sx * sy * cz;
        out[3] = cx * cy * cz + sx * sy * sz;
    }
    return out;
}
const $0b0b47b0a5724ccd$export$784d13d8ee351f07 = $2142ba2b61102ce6$export$784d13d8ee351f07;
const $0b0b47b0a5724ccd$export$adaa4cf7ef1b65be = $2142ba2b61102ce6$export$adaa4cf7ef1b65be;
const $0b0b47b0a5724ccd$export$e16d8520af44a096 = $2142ba2b61102ce6$export$e16d8520af44a096;
const $0b0b47b0a5724ccd$export$dcdf75081b88279d = $2142ba2b61102ce6$export$dcdf75081b88279d;
const $0b0b47b0a5724ccd$export$94132a0e348806d4 = $2142ba2b61102ce6$export$94132a0e348806d4;
const $0b0b47b0a5724ccd$export$3a89f8d6f6bf6c9f = $2142ba2b61102ce6$export$3a89f8d6f6bf6c9f;
const $0b0b47b0a5724ccd$export$f24224f1c91d8156 = $2142ba2b61102ce6$export$f24224f1c91d8156;
const $0b0b47b0a5724ccd$export$a3295358bff77e = $2142ba2b61102ce6$export$a3295358bff77e;


class $e4281cd166358a18$export$5edfe12bb88684c8 extends Array {
    constructor(x = 0, y = 0, z = 0, w = 1){
        super(x, y, z, w);
        this.onChange = ()=>{};
        // Keep reference to proxy target to avoid triggering onChange internally
        this._target = this;
        // Return a proxy to trigger onChange when array elements are edited directly
        const triggerProps = [
            "0",
            "1",
            "2",
            "3"
        ];
        return new Proxy(this, {
            set (target, property) {
                const success = Reflect.set(...arguments);
                if (success && triggerProps.includes(property)) target.onChange();
                return success;
            }
        });
    }
    get x() {
        return this[0];
    }
    get y() {
        return this[1];
    }
    get z() {
        return this[2];
    }
    get w() {
        return this[3];
    }
    set x(v) {
        this._target[0] = v;
        this.onChange();
    }
    set y(v) {
        this._target[1] = v;
        this.onChange();
    }
    set z(v) {
        this._target[2] = v;
        this.onChange();
    }
    set w(v) {
        this._target[3] = v;
        this.onChange();
    }
    identity() {
        $0b0b47b0a5724ccd$export$f0954fd7d5368655(this._target);
        this.onChange();
        return this;
    }
    set(x, y, z, w) {
        if (x.length) return this.copy(x);
        $0b0b47b0a5724ccd$export$adaa4cf7ef1b65be(this._target, x, y, z, w);
        this.onChange();
        return this;
    }
    rotateX(a) {
        $0b0b47b0a5724ccd$export$a59c8716592e09af(this._target, this._target, a);
        this.onChange();
        return this;
    }
    rotateY(a) {
        $0b0b47b0a5724ccd$export$cf71e4d4ca4d1cfd(this._target, this._target, a);
        this.onChange();
        return this;
    }
    rotateZ(a) {
        $0b0b47b0a5724ccd$export$ea6eae3365de5b9c(this._target, this._target, a);
        this.onChange();
        return this;
    }
    inverse(q = this._target) {
        $0b0b47b0a5724ccd$export$6897c284b6f9f4dc(this._target, q);
        this.onChange();
        return this;
    }
    conjugate(q = this._target) {
        $0b0b47b0a5724ccd$export$7679f47e72c62560(this._target, q);
        this.onChange();
        return this;
    }
    copy(q) {
        $0b0b47b0a5724ccd$export$784d13d8ee351f07(this._target, q);
        this.onChange();
        return this;
    }
    normalize(q = this._target) {
        $0b0b47b0a5724ccd$export$a3295358bff77e(this._target, q);
        this.onChange();
        return this;
    }
    multiply(qA, qB) {
        if (qB) $0b0b47b0a5724ccd$export$2060d2db72cce88f(this._target, qA, qB);
        else $0b0b47b0a5724ccd$export$2060d2db72cce88f(this._target, this._target, qA);
        this.onChange();
        return this;
    }
    dot(v) {
        return $0b0b47b0a5724ccd$export$94132a0e348806d4(this._target, v);
    }
    fromMatrix3(matrix3) {
        $0b0b47b0a5724ccd$export$272a1eb8e5a4b55b(this._target, matrix3);
        this.onChange();
        return this;
    }
    fromEuler(euler, isInternal) {
        $0b0b47b0a5724ccd$export$7a404a587ea85af(this._target, euler, euler.order);
        // Avoid infinite recursion
        if (!isInternal) this.onChange();
        return this;
    }
    fromAxisAngle(axis, a) {
        $0b0b47b0a5724ccd$export$4286ddefc8f49512(this._target, axis, a);
        this.onChange();
        return this;
    }
    slerp(q, t) {
        $0b0b47b0a5724ccd$export$1544d9bc2995de08(this._target, this._target, q, t);
        this.onChange();
        return this;
    }
    fromArray(a, o = 0) {
        this._target[0] = a[o];
        this._target[1] = a[o + 1];
        this._target[2] = a[o + 2];
        this._target[3] = a[o + 3];
        this.onChange();
        return this;
    }
    toArray(a = [], o = 0) {
        a[o] = this[0];
        a[o + 1] = this[1];
        a[o + 2] = this[2];
        a[o + 3] = this[3];
        return a;
    }
}



const $17e1720dd2981297$var$EPSILON = 0.000001;
function $17e1720dd2981297$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $17e1720dd2981297$export$adaa4cf7ef1b65be(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $17e1720dd2981297$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $17e1720dd2981297$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        let a01 = a[1], a02 = a[2], a03 = a[3];
        let a12 = a[6], a13 = a[7];
        let a23 = a[11];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a01;
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a02;
        out[9] = a12;
        out[11] = a[14];
        out[12] = a03;
        out[13] = a13;
        out[14] = a23;
    } else {
        out[0] = a[0];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a[1];
        out[5] = a[5];
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a[2];
        out[9] = a[6];
        out[10] = a[10];
        out[11] = a[14];
        out[12] = a[3];
        out[13] = a[7];
        out[14] = a[11];
        out[15] = a[15];
    }
    return out;
}
function $17e1720dd2981297$export$6897c284b6f9f4dc(out, a) {
    let a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    let a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    let a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    let a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    let b00 = a00 * a11 - a01 * a10;
    let b01 = a00 * a12 - a02 * a10;
    let b02 = a00 * a13 - a03 * a10;
    let b03 = a01 * a12 - a02 * a11;
    let b04 = a01 * a13 - a03 * a11;
    let b05 = a02 * a13 - a03 * a12;
    let b06 = a20 * a31 - a21 * a30;
    let b07 = a20 * a32 - a22 * a30;
    let b08 = a20 * a33 - a23 * a30;
    let b09 = a21 * a32 - a22 * a31;
    let b10 = a21 * a33 - a23 * a31;
    let b11 = a22 * a33 - a23 * a32;
    // Calculate the determinant
    let det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
    return out;
}
function $17e1720dd2981297$export$a04698f914c55ed9(a) {
    let a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    let a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    let a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    let a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    let b00 = a00 * a11 - a01 * a10;
    let b01 = a00 * a12 - a02 * a10;
    let b02 = a00 * a13 - a03 * a10;
    let b03 = a01 * a12 - a02 * a11;
    let b04 = a01 * a13 - a03 * a11;
    let b05 = a02 * a13 - a03 * a12;
    let b06 = a20 * a31 - a21 * a30;
    let b07 = a20 * a32 - a22 * a30;
    let b08 = a20 * a33 - a23 * a30;
    let b09 = a21 * a32 - a22 * a31;
    let b10 = a21 * a33 - a23 * a31;
    let b11 = a22 * a33 - a23 * a32;
    // Calculate the determinant
    return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
}
function $17e1720dd2981297$export$2060d2db72cce88f(out, a, b) {
    let a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    let a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    let a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    let a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    // Cache only the current line of the second matrix
    let b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[4];
    b1 = b[5];
    b2 = b[6];
    b3 = b[7];
    out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[8];
    b1 = b[9];
    b2 = b[10];
    b3 = b[11];
    out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[12];
    b1 = b[13];
    b2 = b[14];
    b3 = b[15];
    out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    return out;
}
function $17e1720dd2981297$export$d73ee8ef04f5226a(out, a, v) {
    let x = v[0], y = v[1], z = v[2];
    let a00, a01, a02, a03;
    let a10, a11, a12, a13;
    let a20, a21, a22, a23;
    if (a === out) {
        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    } else {
        a00 = a[0];
        a01 = a[1];
        a02 = a[2];
        a03 = a[3];
        a10 = a[4];
        a11 = a[5];
        a12 = a[6];
        a13 = a[7];
        a20 = a[8];
        a21 = a[9];
        a22 = a[10];
        a23 = a[11];
        out[0] = a00;
        out[1] = a01;
        out[2] = a02;
        out[3] = a03;
        out[4] = a10;
        out[5] = a11;
        out[6] = a12;
        out[7] = a13;
        out[8] = a20;
        out[9] = a21;
        out[10] = a22;
        out[11] = a23;
        out[12] = a00 * x + a10 * y + a20 * z + a[12];
        out[13] = a01 * x + a11 * y + a21 * z + a[13];
        out[14] = a02 * x + a12 * y + a22 * z + a[14];
        out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }
    return out;
}
function $17e1720dd2981297$export$dcdf75081b88279d(out, a, v) {
    let x = v[0], y = v[1], z = v[2];
    out[0] = a[0] * x;
    out[1] = a[1] * x;
    out[2] = a[2] * x;
    out[3] = a[3] * x;
    out[4] = a[4] * y;
    out[5] = a[5] * y;
    out[6] = a[6] * y;
    out[7] = a[7] * y;
    out[8] = a[8] * z;
    out[9] = a[9] * z;
    out[10] = a[10] * z;
    out[11] = a[11] * z;
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $17e1720dd2981297$export$bb628a54ab399bc9(out, a, rad, axis) {
    let x = axis[0], y = axis[1], z = axis[2];
    let len = Math.hypot(x, y, z);
    let s, c, t;
    let a00, a01, a02, a03;
    let a10, a11, a12, a13;
    let a20, a21, a22, a23;
    let b00, b01, b02;
    let b10, b11, b12;
    let b20, b21, b22;
    if (Math.abs(len) < $17e1720dd2981297$var$EPSILON) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11];
    // Construct the elements of the rotation matrix
    b00 = x * x * t + c;
    b01 = y * x * t + z * s;
    b02 = z * x * t - y * s;
    b10 = x * y * t - z * s;
    b11 = y * y * t + c;
    b12 = z * y * t + x * s;
    b20 = x * z * t + y * s;
    b21 = y * z * t - x * s;
    b22 = z * z * t + c;
    // Perform rotation-specific matrix multiplication
    out[0] = a00 * b00 + a10 * b01 + a20 * b02;
    out[1] = a01 * b00 + a11 * b01 + a21 * b02;
    out[2] = a02 * b00 + a12 * b01 + a22 * b02;
    out[3] = a03 * b00 + a13 * b01 + a23 * b02;
    out[4] = a00 * b10 + a10 * b11 + a20 * b12;
    out[5] = a01 * b10 + a11 * b11 + a21 * b12;
    out[6] = a02 * b10 + a12 * b11 + a22 * b12;
    out[7] = a03 * b10 + a13 * b11 + a23 * b12;
    out[8] = a00 * b20 + a10 * b21 + a20 * b22;
    out[9] = a01 * b20 + a11 * b21 + a21 * b22;
    out[10] = a02 * b20 + a12 * b21 + a22 * b22;
    out[11] = a03 * b20 + a13 * b21 + a23 * b22;
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    return out;
}
function $17e1720dd2981297$export$202e99f82f7f0395(out, mat) {
    out[0] = mat[12];
    out[1] = mat[13];
    out[2] = mat[14];
    return out;
}
function $17e1720dd2981297$export$71dc54d92bd04b57(out, mat) {
    let m11 = mat[0];
    let m12 = mat[1];
    let m13 = mat[2];
    let m21 = mat[4];
    let m22 = mat[5];
    let m23 = mat[6];
    let m31 = mat[8];
    let m32 = mat[9];
    let m33 = mat[10];
    out[0] = Math.hypot(m11, m12, m13);
    out[1] = Math.hypot(m21, m22, m23);
    out[2] = Math.hypot(m31, m32, m33);
    return out;
}
function $17e1720dd2981297$export$6276f53cd18ff805(mat) {
    let m11 = mat[0];
    let m12 = mat[1];
    let m13 = mat[2];
    let m21 = mat[4];
    let m22 = mat[5];
    let m23 = mat[6];
    let m31 = mat[8];
    let m32 = mat[9];
    let m33 = mat[10];
    const x = m11 * m11 + m12 * m12 + m13 * m13;
    const y = m21 * m21 + m22 * m22 + m23 * m23;
    const z = m31 * m31 + m32 * m32 + m33 * m33;
    return Math.sqrt(Math.max(x, y, z));
}
const $17e1720dd2981297$export$df3937d3b537df0a = function() {
    const temp = [
        1,
        1,
        1
    ];
    return function(out, mat) {
        let scaling = temp;
        $17e1720dd2981297$export$71dc54d92bd04b57(scaling, mat);
        let is1 = 1 / scaling[0];
        let is2 = 1 / scaling[1];
        let is3 = 1 / scaling[2];
        let sm11 = mat[0] * is1;
        let sm12 = mat[1] * is2;
        let sm13 = mat[2] * is3;
        let sm21 = mat[4] * is1;
        let sm22 = mat[5] * is2;
        let sm23 = mat[6] * is3;
        let sm31 = mat[8] * is1;
        let sm32 = mat[9] * is2;
        let sm33 = mat[10] * is3;
        let trace = sm11 + sm22 + sm33;
        let S = 0;
        if (trace > 0) {
            S = Math.sqrt(trace + 1.0) * 2;
            out[3] = 0.25 * S;
            out[0] = (sm23 - sm32) / S;
            out[1] = (sm31 - sm13) / S;
            out[2] = (sm12 - sm21) / S;
        } else if (sm11 > sm22 && sm11 > sm33) {
            S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
            out[3] = (sm23 - sm32) / S;
            out[0] = 0.25 * S;
            out[1] = (sm12 + sm21) / S;
            out[2] = (sm31 + sm13) / S;
        } else if (sm22 > sm33) {
            S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
            out[3] = (sm31 - sm13) / S;
            out[0] = (sm12 + sm21) / S;
            out[1] = 0.25 * S;
            out[2] = (sm23 + sm32) / S;
        } else {
            S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
            out[3] = (sm12 - sm21) / S;
            out[0] = (sm31 + sm13) / S;
            out[1] = (sm23 + sm32) / S;
            out[2] = 0.25 * S;
        }
        return out;
    };
}();
function $17e1720dd2981297$export$4e06b4a690896b27(srcMat, dstRotation, dstTranslation, dstScale) {
    let sx = $fcf02a95a4622ee8$export$f24224f1c91d8156([
        srcMat[0],
        srcMat[1],
        srcMat[2]
    ]);
    const sy = $fcf02a95a4622ee8$export$f24224f1c91d8156([
        srcMat[4],
        srcMat[5],
        srcMat[6]
    ]);
    const sz = $fcf02a95a4622ee8$export$f24224f1c91d8156([
        srcMat[8],
        srcMat[9],
        srcMat[10]
    ]);
    // if determine is negative, we need to invert one scale
    const det = $17e1720dd2981297$export$a04698f914c55ed9(srcMat);
    if (det < 0) sx = -sx;
    dstTranslation[0] = srcMat[12];
    dstTranslation[1] = srcMat[13];
    dstTranslation[2] = srcMat[14];
    // scale the rotation part
    const _m1 = srcMat.slice();
    const invSX = 1 / sx;
    const invSY = 1 / sy;
    const invSZ = 1 / sz;
    _m1[0] *= invSX;
    _m1[1] *= invSX;
    _m1[2] *= invSX;
    _m1[4] *= invSY;
    _m1[5] *= invSY;
    _m1[6] *= invSY;
    _m1[8] *= invSZ;
    _m1[9] *= invSZ;
    _m1[10] *= invSZ;
    $17e1720dd2981297$export$df3937d3b537df0a(dstRotation, _m1);
    dstScale[0] = sx;
    dstScale[1] = sy;
    dstScale[2] = sz;
}
function $17e1720dd2981297$export$f672e0b6f7222cd7(dstMat, srcRotation, srcTranslation, srcScale) {
    const te = dstMat;
    const x = srcRotation[0], y = srcRotation[1], z = srcRotation[2], w = srcRotation[3];
    const x2 = x + x, y2 = y + y, z2 = z + z;
    const xx = x * x2, xy = x * y2, xz = x * z2;
    const yy = y * y2, yz = y * z2, zz = z * z2;
    const wx = w * x2, wy = w * y2, wz = w * z2;
    const sx = srcScale[0], sy = srcScale[1], sz = srcScale[2];
    te[0] = (1 - (yy + zz)) * sx;
    te[1] = (xy + wz) * sx;
    te[2] = (xz - wy) * sx;
    te[3] = 0;
    te[4] = (xy - wz) * sy;
    te[5] = (1 - (xx + zz)) * sy;
    te[6] = (yz + wx) * sy;
    te[7] = 0;
    te[8] = (xz + wy) * sz;
    te[9] = (yz - wx) * sz;
    te[10] = (1 - (xx + yy)) * sz;
    te[11] = 0;
    te[12] = srcTranslation[0];
    te[13] = srcTranslation[1];
    te[14] = srcTranslation[2];
    te[15] = 1;
    return te;
}
function $17e1720dd2981297$export$ddf9c55c9f2be172(out, q, v, s) {
    // Quaternion math
    let x = q[0], y = q[1], z = q[2], w = q[3];
    let x2 = x + x;
    let y2 = y + y;
    let z2 = z + z;
    let xx = x * x2;
    let xy = x * y2;
    let xz = x * z2;
    let yy = y * y2;
    let yz = y * z2;
    let zz = z * z2;
    let wx = w * x2;
    let wy = w * y2;
    let wz = w * z2;
    let sx = s[0];
    let sy = s[1];
    let sz = s[2];
    out[0] = (1 - (yy + zz)) * sx;
    out[1] = (xy + wz) * sx;
    out[2] = (xz - wy) * sx;
    out[3] = 0;
    out[4] = (xy - wz) * sy;
    out[5] = (1 - (xx + zz)) * sy;
    out[6] = (yz + wx) * sy;
    out[7] = 0;
    out[8] = (xz + wy) * sz;
    out[9] = (yz - wx) * sz;
    out[10] = (1 - (xx + yy)) * sz;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $17e1720dd2981297$export$2ff2bbe382249af7(out, q) {
    let x = q[0], y = q[1], z = q[2], w = q[3];
    let x2 = x + x;
    let y2 = y + y;
    let z2 = z + z;
    let xx = x * x2;
    let yx = y * x2;
    let yy = y * y2;
    let zx = z * x2;
    let zy = z * y2;
    let zz = z * z2;
    let wx = w * x2;
    let wy = w * y2;
    let wz = w * z2;
    out[0] = 1 - yy - zz;
    out[1] = yx + wz;
    out[2] = zx - wy;
    out[3] = 0;
    out[4] = yx - wz;
    out[5] = 1 - xx - zz;
    out[6] = zy + wx;
    out[7] = 0;
    out[8] = zx + wy;
    out[9] = zy - wx;
    out[10] = 1 - xx - yy;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $17e1720dd2981297$export$541149539f3a4684(out, fovy, aspect, near, far) {
    let f = 1.0 / Math.tan(fovy / 2);
    let nf = 1 / (near - far);
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = 2 * far * near * nf;
    out[15] = 0;
    return out;
}
function $17e1720dd2981297$export$4f2167e613cfc87b(out, left, right, bottom, top, near, far) {
    let lr = 1 / (left - right);
    let bt = 1 / (bottom - top);
    let nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 2 * nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = (far + near) * nf;
    out[15] = 1;
    return out;
}
function $17e1720dd2981297$export$aa67782f4dc9e52c(out, eye, target, up) {
    let eyex = eye[0], eyey = eye[1], eyez = eye[2], upx = up[0], upy = up[1], upz = up[2];
    let z0 = eyex - target[0], z1 = eyey - target[1], z2 = eyez - target[2];
    let len = z0 * z0 + z1 * z1 + z2 * z2;
    if (len === 0) // eye and target are in the same position
    z2 = 1;
    else {
        len = 1 / Math.sqrt(len);
        z0 *= len;
        z1 *= len;
        z2 *= len;
    }
    let x0 = upy * z2 - upz * z1, x1 = upz * z0 - upx * z2, x2 = upx * z1 - upy * z0;
    len = x0 * x0 + x1 * x1 + x2 * x2;
    if (len === 0) {
        // up and z are parallel
        if (upz) upx += 1e-6;
        else if (upy) upz += 1e-6;
        else upy += 1e-6;
        x0 = upy * z2 - upz * z1, x1 = upz * z0 - upx * z2, x2 = upx * z1 - upy * z0;
        len = x0 * x0 + x1 * x1 + x2 * x2;
    }
    len = 1 / Math.sqrt(len);
    x0 *= len;
    x1 *= len;
    x2 *= len;
    out[0] = x0;
    out[1] = x1;
    out[2] = x2;
    out[3] = 0;
    out[4] = z1 * x2 - z2 * x1;
    out[5] = z2 * x0 - z0 * x2;
    out[6] = z0 * x1 - z1 * x0;
    out[7] = 0;
    out[8] = z0;
    out[9] = z1;
    out[10] = z2;
    out[11] = 0;
    out[12] = eyex;
    out[13] = eyey;
    out[14] = eyez;
    out[15] = 1;
    return out;
}
function $17e1720dd2981297$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    out[9] = a[9] + b[9];
    out[10] = a[10] + b[10];
    out[11] = a[11] + b[11];
    out[12] = a[12] + b[12];
    out[13] = a[13] + b[13];
    out[14] = a[14] + b[14];
    out[15] = a[15] + b[15];
    return out;
}
function $17e1720dd2981297$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    out[9] = a[9] - b[9];
    out[10] = a[10] - b[10];
    out[11] = a[11] - b[11];
    out[12] = a[12] - b[12];
    out[13] = a[13] - b[13];
    out[14] = a[14] - b[14];
    out[15] = a[15] - b[15];
    return out;
}
function $17e1720dd2981297$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    out[9] = a[9] * b;
    out[10] = a[10] * b;
    out[11] = a[11] * b;
    out[12] = a[12] * b;
    out[13] = a[13] * b;
    out[14] = a[14] * b;
    out[15] = a[15] * b;
    return out;
}


class $4e21c701cd686be1$export$21c0e3d5e995d7e1 extends Array {
    constructor(m00 = 1, m01 = 0, m02 = 0, m03 = 0, m10 = 0, m11 = 1, m12 = 0, m13 = 0, m20 = 0, m21 = 0, m22 = 1, m23 = 0, m30 = 0, m31 = 0, m32 = 0, m33 = 1){
        super(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33);
        return this;
    }
    get x() {
        return this[12];
    }
    get y() {
        return this[13];
    }
    get z() {
        return this[14];
    }
    get w() {
        return this[15];
    }
    set x(v) {
        this[12] = v;
    }
    set y(v) {
        this[13] = v;
    }
    set z(v) {
        this[14] = v;
    }
    set w(v) {
        this[15] = v;
    }
    set(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
        if (m00.length) return this.copy(m00);
        $17e1720dd2981297$export$adaa4cf7ef1b65be(this, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33);
        return this;
    }
    translate(v, m = this) {
        $17e1720dd2981297$export$d73ee8ef04f5226a(this, m, v);
        return this;
    }
    rotate(v, axis, m = this) {
        $17e1720dd2981297$export$bb628a54ab399bc9(this, m, v, axis);
        return this;
    }
    scale(v, m = this) {
        $17e1720dd2981297$export$dcdf75081b88279d(this, m, typeof v === "number" ? [
            v,
            v,
            v
        ] : v);
        return this;
    }
    add(ma, mb) {
        if (mb) $17e1720dd2981297$export$e16d8520af44a096(this, ma, mb);
        else $17e1720dd2981297$export$e16d8520af44a096(this, this, ma);
        return this;
    }
    sub(ma, mb) {
        if (mb) $17e1720dd2981297$export$4e2d2ead65e5f7e3(this, ma, mb);
        else $17e1720dd2981297$export$4e2d2ead65e5f7e3(this, this, ma);
        return this;
    }
    multiply(ma, mb) {
        if (!ma.length) $17e1720dd2981297$export$c697bed75648cdb7(this, this, ma);
        else if (mb) $17e1720dd2981297$export$2060d2db72cce88f(this, ma, mb);
        else $17e1720dd2981297$export$2060d2db72cce88f(this, this, ma);
        return this;
    }
    identity() {
        $17e1720dd2981297$export$f0954fd7d5368655(this);
        return this;
    }
    copy(m) {
        $17e1720dd2981297$export$784d13d8ee351f07(this, m);
        return this;
    }
    fromPerspective({ fov: fov, aspect: aspect, near: near, far: far } = {}) {
        $17e1720dd2981297$export$541149539f3a4684(this, fov, aspect, near, far);
        return this;
    }
    fromOrthogonal({ left: left, right: right, bottom: bottom, top: top, near: near, far: far }) {
        $17e1720dd2981297$export$4f2167e613cfc87b(this, left, right, bottom, top, near, far);
        return this;
    }
    fromQuaternion(q) {
        $17e1720dd2981297$export$2ff2bbe382249af7(this, q);
        return this;
    }
    setPosition(v) {
        this.x = v[0];
        this.y = v[1];
        this.z = v[2];
        return this;
    }
    inverse(m = this) {
        $17e1720dd2981297$export$6897c284b6f9f4dc(this, m);
        return this;
    }
    compose(q, pos, scale) {
        $17e1720dd2981297$export$f672e0b6f7222cd7(this, q, pos, scale);
        return this;
    }
    decompose(q, pos, scale) {
        $17e1720dd2981297$export$4e06b4a690896b27(this, q, pos, scale);
        return this;
    }
    getRotation(q) {
        $17e1720dd2981297$export$df3937d3b537df0a(q, this);
        return this;
    }
    getTranslation(pos) {
        $17e1720dd2981297$export$202e99f82f7f0395(pos, this);
        return this;
    }
    getScaling(scale) {
        $17e1720dd2981297$export$71dc54d92bd04b57(scale, this);
        return this;
    }
    getMaxScaleOnAxis() {
        return $17e1720dd2981297$export$6276f53cd18ff805(this);
    }
    lookAt(eye, target, up) {
        $17e1720dd2981297$export$aa67782f4dc9e52c(this, eye, target, up);
        return this;
    }
    determinant() {
        return $17e1720dd2981297$export$a04698f914c55ed9(this);
    }
    fromArray(a, o = 0) {
        this[0] = a[o];
        this[1] = a[o + 1];
        this[2] = a[o + 2];
        this[3] = a[o + 3];
        this[4] = a[o + 4];
        this[5] = a[o + 5];
        this[6] = a[o + 6];
        this[7] = a[o + 7];
        this[8] = a[o + 8];
        this[9] = a[o + 9];
        this[10] = a[o + 10];
        this[11] = a[o + 11];
        this[12] = a[o + 12];
        this[13] = a[o + 13];
        this[14] = a[o + 14];
        this[15] = a[o + 15];
        return this;
    }
    toArray(a = [], o = 0) {
        a[o] = this[0];
        a[o + 1] = this[1];
        a[o + 2] = this[2];
        a[o + 3] = this[3];
        a[o + 4] = this[4];
        a[o + 5] = this[5];
        a[o + 6] = this[6];
        a[o + 7] = this[7];
        a[o + 8] = this[8];
        a[o + 9] = this[9];
        a[o + 10] = this[10];
        a[o + 11] = this[11];
        a[o + 12] = this[12];
        a[o + 13] = this[13];
        a[o + 14] = this[14];
        a[o + 15] = this[15];
        return a;
    }
}


// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
function $ee536ae28bcc5e05$export$48889b85f55f068c(out, m, order = "YXZ") {
    if (order === "XYZ") {
        out[1] = Math.asin(Math.min(Math.max(m[8], -1), 1));
        if (Math.abs(m[8]) < 0.99999) {
            out[0] = Math.atan2(-m[9], m[10]);
            out[2] = Math.atan2(-m[4], m[0]);
        } else {
            out[0] = Math.atan2(m[6], m[5]);
            out[2] = 0;
        }
    } else if (order === "YXZ") {
        out[0] = Math.asin(-Math.min(Math.max(m[9], -1), 1));
        if (Math.abs(m[9]) < 0.99999) {
            out[1] = Math.atan2(m[8], m[10]);
            out[2] = Math.atan2(m[1], m[5]);
        } else {
            out[1] = Math.atan2(-m[2], m[0]);
            out[2] = 0;
        }
    } else if (order === "ZXY") {
        out[0] = Math.asin(Math.min(Math.max(m[6], -1), 1));
        if (Math.abs(m[6]) < 0.99999) {
            out[1] = Math.atan2(-m[2], m[10]);
            out[2] = Math.atan2(-m[4], m[5]);
        } else {
            out[1] = 0;
            out[2] = Math.atan2(m[1], m[0]);
        }
    } else if (order === "ZYX") {
        out[1] = Math.asin(-Math.min(Math.max(m[2], -1), 1));
        if (Math.abs(m[2]) < 0.99999) {
            out[0] = Math.atan2(m[6], m[10]);
            out[2] = Math.atan2(m[1], m[0]);
        } else {
            out[0] = 0;
            out[2] = Math.atan2(-m[4], m[5]);
        }
    } else if (order === "YZX") {
        out[2] = Math.asin(Math.min(Math.max(m[1], -1), 1));
        if (Math.abs(m[1]) < 0.99999) {
            out[0] = Math.atan2(-m[9], m[5]);
            out[1] = Math.atan2(-m[2], m[0]);
        } else {
            out[0] = 0;
            out[1] = Math.atan2(m[8], m[10]);
        }
    } else if (order === "XZY") {
        out[2] = Math.asin(-Math.min(Math.max(m[4], -1), 1));
        if (Math.abs(m[4]) < 0.99999) {
            out[0] = Math.atan2(m[6], m[5]);
            out[1] = Math.atan2(m[8], m[0]);
        } else {
            out[0] = Math.atan2(-m[9], m[10]);
            out[1] = 0;
        }
    }
    return out;
}



const $5f514479e80f605c$var$tmpMat4 = /* @__PURE__ */ new (0, $4e21c701cd686be1$export$21c0e3d5e995d7e1)();
class $5f514479e80f605c$export$d93cc409a0768c5f extends Array {
    constructor(x = 0, y = x, z = x, order = "YXZ"){
        super(x, y, z);
        this.order = order;
        this.onChange = ()=>{};
        // Keep reference to proxy target to avoid triggering onChange internally
        this._target = this;
        // Return a proxy to trigger onChange when array elements are edited directly
        const triggerProps = [
            "0",
            "1",
            "2"
        ];
        return new Proxy(this, {
            set (target, property) {
                const success = Reflect.set(...arguments);
                if (success && triggerProps.includes(property)) target.onChange();
                return success;
            }
        });
    }
    get x() {
        return this[0];
    }
    get y() {
        return this[1];
    }
    get z() {
        return this[2];
    }
    set x(v) {
        this._target[0] = v;
        this.onChange();
    }
    set y(v) {
        this._target[1] = v;
        this.onChange();
    }
    set z(v) {
        this._target[2] = v;
        this.onChange();
    }
    set(x, y = x, z = x) {
        if (x.length) return this.copy(x);
        this._target[0] = x;
        this._target[1] = y;
        this._target[2] = z;
        this.onChange();
        return this;
    }
    copy(v) {
        this._target[0] = v[0];
        this._target[1] = v[1];
        this._target[2] = v[2];
        this.onChange();
        return this;
    }
    reorder(order) {
        this._target.order = order;
        this.onChange();
        return this;
    }
    fromRotationMatrix(m, order = this.order) {
        $ee536ae28bcc5e05$export$48889b85f55f068c(this._target, m, order);
        this.onChange();
        return this;
    }
    fromQuaternion(q, order = this.order, isInternal) {
        $5f514479e80f605c$var$tmpMat4.fromQuaternion(q);
        this._target.fromRotationMatrix($5f514479e80f605c$var$tmpMat4, order);
        // Avoid infinite recursion
        if (!isInternal) this.onChange();
        return this;
    }
    fromArray(a, o = 0) {
        this._target[0] = a[o];
        this._target[1] = a[o + 1];
        this._target[2] = a[o + 2];
        return this;
    }
    toArray(a = [], o = 0) {
        a[o] = this[0];
        a[o + 1] = this[1];
        a[o + 2] = this[2];
        return a;
    }
}


class $b99754c4edbe0b63$export$563a914cafbdc389 {
    constructor(){
        this.parent = null;
        this.children = [];
        this.visible = true;
        this.matrix = new (0, $4e21c701cd686be1$export$21c0e3d5e995d7e1)();
        this.worldMatrix = new (0, $4e21c701cd686be1$export$21c0e3d5e995d7e1)();
        this.matrixAutoUpdate = true;
        this.worldMatrixNeedsUpdate = false;
        this.position = new (0, $46d76f993ed555f5$export$838423f3adec30fa)();
        this.quaternion = new (0, $e4281cd166358a18$export$5edfe12bb88684c8)();
        this.scale = new (0, $46d76f993ed555f5$export$838423f3adec30fa)(1);
        this.rotation = new (0, $5f514479e80f605c$export$d93cc409a0768c5f)();
        this.up = new (0, $46d76f993ed555f5$export$838423f3adec30fa)(0, 1, 0);
        this.rotation._target.onChange = ()=>this.quaternion.fromEuler(this.rotation, true);
        this.quaternion._target.onChange = ()=>this.rotation.fromQuaternion(this.quaternion, undefined, true);
    }
    setParent(parent, notifyParent = true) {
        if (this.parent && parent !== this.parent) this.parent.removeChild(this, false);
        this.parent = parent;
        if (notifyParent && parent) parent.addChild(this, false);
    }
    addChild(child, notifyChild = true) {
        if (!~this.children.indexOf(child)) this.children.push(child);
        if (notifyChild) child.setParent(this, false);
    }
    removeChild(child, notifyChild = true) {
        if (!!~this.children.indexOf(child)) this.children.splice(this.children.indexOf(child), 1);
        if (notifyChild) child.setParent(null, false);
    }
    updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.worldMatrixNeedsUpdate || force) {
            if (this.parent === null) this.worldMatrix.copy(this.matrix);
            else this.worldMatrix.multiply(this.parent.worldMatrix, this.matrix);
            this.worldMatrixNeedsUpdate = false;
            force = true;
        }
        for(let i = 0, l = this.children.length; i < l; i++)this.children[i].updateMatrixWorld(force);
    }
    updateMatrix() {
        this.matrix.compose(this.quaternion, this.position, this.scale);
        this.worldMatrixNeedsUpdate = true;
    }
    traverse(callback) {
        // Return true in callback to stop traversing children
        if (callback(this)) return;
        for(let i = 0, l = this.children.length; i < l; i++)this.children[i].traverse(callback);
    }
    decompose() {
        this.matrix.decompose(this.quaternion._target, this.position, this.scale);
        this.rotation.fromQuaternion(this.quaternion);
    }
    lookAt(target, invert = false) {
        if (invert) this.matrix.lookAt(this.position, target, this.up);
        else this.matrix.lookAt(target, this.position, this.up);
        this.matrix.getRotation(this.quaternion._target);
        this.rotation.fromQuaternion(this.quaternion);
    }
}




const $0725581459e32093$var$tempMat4 = /* @__PURE__ */ new (0, $4e21c701cd686be1$export$21c0e3d5e995d7e1)();
const $0725581459e32093$var$tempVec3a = /* @__PURE__ */ new (0, $46d76f993ed555f5$export$838423f3adec30fa)();
const $0725581459e32093$var$tempVec3b = /* @__PURE__ */ new (0, $46d76f993ed555f5$export$838423f3adec30fa)();
class $0725581459e32093$export$79f141de891a5fed extends (0, $b99754c4edbe0b63$export$563a914cafbdc389) {
    constructor(gl, { near: near = 0.1, far: far = 100, fov: fov = 45, aspect: aspect = 1, left: left, right: right, bottom: bottom, top: top, zoom: zoom = 1 } = {}){
        super();
        Object.assign(this, {
            near: near,
            far: far,
            fov: fov,
            aspect: aspect,
            left: left,
            right: right,
            bottom: bottom,
            top: top,
            zoom: zoom
        });
        this.projectionMatrix = new (0, $4e21c701cd686be1$export$21c0e3d5e995d7e1)();
        this.viewMatrix = new (0, $4e21c701cd686be1$export$21c0e3d5e995d7e1)();
        this.projectionViewMatrix = new (0, $4e21c701cd686be1$export$21c0e3d5e995d7e1)();
        this.worldPosition = new (0, $46d76f993ed555f5$export$838423f3adec30fa)();
        // Use orthographic if left/right set, else default to perspective camera
        this.type = left || right ? "orthographic" : "perspective";
        if (this.type === "orthographic") this.orthographic();
        else this.perspective();
    }
    perspective({ near: near = this.near, far: far = this.far, fov: fov = this.fov, aspect: aspect = this.aspect } = {}) {
        Object.assign(this, {
            near: near,
            far: far,
            fov: fov,
            aspect: aspect
        });
        this.projectionMatrix.fromPerspective({
            fov: fov * (Math.PI / 180),
            aspect: aspect,
            near: near,
            far: far
        });
        this.type = "perspective";
        return this;
    }
    orthographic({ near: near = this.near, far: far = this.far, left: left = this.left || -1, right: right = this.right || 1, bottom: bottom = this.bottom || -1, top: top = this.top || 1, zoom: zoom = this.zoom } = {}) {
        Object.assign(this, {
            near: near,
            far: far,
            left: left,
            right: right,
            bottom: bottom,
            top: top,
            zoom: zoom
        });
        left /= zoom;
        right /= zoom;
        bottom /= zoom;
        top /= zoom;
        this.projectionMatrix.fromOrthogonal({
            left: left,
            right: right,
            bottom: bottom,
            top: top,
            near: near,
            far: far
        });
        this.type = "orthographic";
        return this;
    }
    updateMatrixWorld() {
        super.updateMatrixWorld();
        this.viewMatrix.inverse(this.worldMatrix);
        this.worldMatrix.getTranslation(this.worldPosition);
        // used for sorting
        this.projectionViewMatrix.multiply(this.projectionMatrix, this.viewMatrix);
        return this;
    }
    lookAt(target) {
        super.lookAt(target, true);
        return this;
    }
    // Project 3D coordinate to 2D point
    project(v) {
        v.applyMatrix4(this.viewMatrix);
        v.applyMatrix4(this.projectionMatrix);
        return this;
    }
    // Unproject 2D point to 3D coordinate
    unproject(v) {
        v.applyMatrix4($0725581459e32093$var$tempMat4.inverse(this.projectionMatrix));
        v.applyMatrix4(this.worldMatrix);
        return this;
    }
    updateFrustum() {
        if (!this.frustum) this.frustum = [
            new (0, $46d76f993ed555f5$export$838423f3adec30fa)(),
            new (0, $46d76f993ed555f5$export$838423f3adec30fa)(),
            new (0, $46d76f993ed555f5$export$838423f3adec30fa)(),
            new (0, $46d76f993ed555f5$export$838423f3adec30fa)(),
            new (0, $46d76f993ed555f5$export$838423f3adec30fa)(),
            new (0, $46d76f993ed555f5$export$838423f3adec30fa)()
        ];
        const m = this.projectionViewMatrix;
        this.frustum[0].set(m[3] - m[0], m[7] - m[4], m[11] - m[8]).constant = m[15] - m[12]; // -x
        this.frustum[1].set(m[3] + m[0], m[7] + m[4], m[11] + m[8]).constant = m[15] + m[12]; // +x
        this.frustum[2].set(m[3] + m[1], m[7] + m[5], m[11] + m[9]).constant = m[15] + m[13]; // +y
        this.frustum[3].set(m[3] - m[1], m[7] - m[5], m[11] - m[9]).constant = m[15] - m[13]; // -y
        this.frustum[4].set(m[3] - m[2], m[7] - m[6], m[11] - m[10]).constant = m[15] - m[14]; // +z (far)
        this.frustum[5].set(m[3] + m[2], m[7] + m[6], m[11] + m[10]).constant = m[15] + m[14]; // -z (near)
        for(let i = 0; i < 6; i++){
            const invLen = 1.0 / this.frustum[i].distance();
            this.frustum[i].multiply(invLen);
            this.frustum[i].constant *= invLen;
        }
    }
    frustumIntersectsMesh(node, worldMatrix = node.worldMatrix) {
        // If no position attribute, treat as frustumCulled false
        if (!node.geometry.attributes.position) return true;
        if (!node.geometry.bounds || node.geometry.bounds.radius === Infinity) node.geometry.computeBoundingSphere();
        if (!node.geometry.bounds) return true;
        const center = $0725581459e32093$var$tempVec3a;
        center.copy(node.geometry.bounds.center);
        center.applyMatrix4(worldMatrix);
        const radius = node.geometry.bounds.radius * worldMatrix.getMaxScaleOnAxis();
        return this.frustumIntersectsSphere(center, radius);
    }
    frustumIntersectsSphere(center, radius) {
        const normal = $0725581459e32093$var$tempVec3b;
        for(let i = 0; i < 6; i++){
            const plane = this.frustum[i];
            const distance = normal.copy(plane).dot(center) + plane.constant;
            if (distance < -radius) return false;
        }
        return true;
    }
}


// TODO: Handle context loss https://www.khronos.org/webgl/wiki/HandlingContextLost
// Not automatic - devs to use these methods manually
// gl.colorMask( colorMask, colorMask, colorMask, colorMask );
// gl.clearColor( r, g, b, a );
// gl.stencilMask( stencilMask );
// gl.stencilFunc( stencilFunc, stencilRef, stencilMask );
// gl.stencilOp( stencilFail, stencilZFail, stencilZPass );
// gl.clearStencil( stencil );
const $b5a73110aaf50409$var$tempVec3 = /* @__PURE__ */ new (0, $46d76f993ed555f5$export$838423f3adec30fa)();
let $b5a73110aaf50409$var$ID = 1;
class $b5a73110aaf50409$export$88530751e3977073 {
    constructor({ canvas: canvas = document.createElement("canvas"), width: width = 300, height: height = 150, dpr: dpr = 1, alpha: alpha = false, depth: depth = true, stencil: stencil = false, antialias: antialias = false, premultipliedAlpha: premultipliedAlpha = false, preserveDrawingBuffer: preserveDrawingBuffer = false, powerPreference: powerPreference = "default", autoClear: autoClear = true, webgl: webgl = 2 } = {}){
        const attributes = {
            alpha: alpha,
            depth: depth,
            stencil: stencil,
            antialias: antialias,
            premultipliedAlpha: premultipliedAlpha,
            preserveDrawingBuffer: preserveDrawingBuffer,
            powerPreference: powerPreference
        };
        this.dpr = dpr;
        this.alpha = alpha;
        this.color = true;
        this.depth = depth;
        this.stencil = stencil;
        this.premultipliedAlpha = premultipliedAlpha;
        this.autoClear = autoClear;
        this.id = $b5a73110aaf50409$var$ID++;
        // Attempt WebGL2 unless forced to 1, if not supported fallback to WebGL1
        if (webgl === 2) this.gl = canvas.getContext("webgl2", attributes);
        this.isWebgl2 = !!this.gl;
        if (!this.gl) this.gl = canvas.getContext("webgl", attributes);
        if (!this.gl) console.error("unable to create webgl context");
        // Attach renderer to gl so that all classes have access to internal state functions
        this.gl.renderer = this;
        // initialise size values
        this.setSize(width, height);
        // gl state stores to avoid redundant calls on methods used internally
        this.state = {};
        this.state.blendFunc = {
            src: this.gl.ONE,
            dst: this.gl.ZERO
        };
        this.state.blendEquation = {
            modeRGB: this.gl.FUNC_ADD
        };
        this.state.cullFace = false;
        this.state.frontFace = this.gl.CCW;
        this.state.depthMask = true;
        this.state.depthFunc = this.gl.LEQUAL;
        this.state.premultiplyAlpha = false;
        this.state.flipY = false;
        this.state.unpackAlignment = 4;
        this.state.framebuffer = null;
        this.state.viewport = {
            x: 0,
            y: 0,
            width: null,
            height: null
        };
        this.state.textureUnits = [];
        this.state.activeTextureUnit = 0;
        this.state.boundBuffer = null;
        this.state.uniformLocations = new Map();
        this.state.currentProgram = null;
        // store requested extensions
        this.extensions = {};
        // Initialise extra format types
        if (this.isWebgl2) {
            this.getExtension("EXT_color_buffer_float");
            this.getExtension("OES_texture_float_linear");
        } else {
            this.getExtension("OES_texture_float");
            this.getExtension("OES_texture_float_linear");
            this.getExtension("OES_texture_half_float");
            this.getExtension("OES_texture_half_float_linear");
            this.getExtension("OES_element_index_uint");
            this.getExtension("OES_standard_derivatives");
            this.getExtension("EXT_sRGB");
            this.getExtension("WEBGL_depth_texture");
            this.getExtension("WEBGL_draw_buffers");
        }
        this.getExtension("WEBGL_compressed_texture_astc");
        this.getExtension("EXT_texture_compression_bptc");
        this.getExtension("WEBGL_compressed_texture_s3tc");
        this.getExtension("WEBGL_compressed_texture_etc1");
        this.getExtension("WEBGL_compressed_texture_pvrtc");
        this.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
        // Create method aliases using extension (WebGL1) or native if available (WebGL2)
        this.vertexAttribDivisor = this.getExtension("ANGLE_instanced_arrays", "vertexAttribDivisor", "vertexAttribDivisorANGLE");
        this.drawArraysInstanced = this.getExtension("ANGLE_instanced_arrays", "drawArraysInstanced", "drawArraysInstancedANGLE");
        this.drawElementsInstanced = this.getExtension("ANGLE_instanced_arrays", "drawElementsInstanced", "drawElementsInstancedANGLE");
        this.createVertexArray = this.getExtension("OES_vertex_array_object", "createVertexArray", "createVertexArrayOES");
        this.bindVertexArray = this.getExtension("OES_vertex_array_object", "bindVertexArray", "bindVertexArrayOES");
        this.deleteVertexArray = this.getExtension("OES_vertex_array_object", "deleteVertexArray", "deleteVertexArrayOES");
        this.drawBuffers = this.getExtension("WEBGL_draw_buffers", "drawBuffers", "drawBuffersWEBGL");
        // Store device parameters
        this.parameters = {};
        this.parameters.maxTextureUnits = this.gl.getParameter(this.gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
        this.parameters.maxAnisotropy = this.getExtension("EXT_texture_filter_anisotropic") ? this.gl.getParameter(this.getExtension("EXT_texture_filter_anisotropic").MAX_TEXTURE_MAX_ANISOTROPY_EXT) : 0;
    }
    setSize(width, height) {
        this.width = width;
        this.height = height;
        this.gl.canvas.width = width * this.dpr;
        this.gl.canvas.height = height * this.dpr;
        if (!this.gl.canvas.style) return;
        Object.assign(this.gl.canvas.style, {
            width: width + "px",
            height: height + "px"
        });
    }
    setViewport(width, height, x = 0, y = 0) {
        if (this.state.viewport.width === width && this.state.viewport.height === height) return;
        this.state.viewport.width = width;
        this.state.viewport.height = height;
        this.state.viewport.x = x;
        this.state.viewport.y = y;
        this.gl.viewport(x, y, width, height);
    }
    setScissor(width, height, x = 0, y = 0) {
        this.gl.scissor(x, y, width, height);
    }
    enable(id) {
        if (this.state[id] === true) return;
        this.gl.enable(id);
        this.state[id] = true;
    }
    disable(id) {
        if (this.state[id] === false) return;
        this.gl.disable(id);
        this.state[id] = false;
    }
    setBlendFunc(src, dst, srcAlpha, dstAlpha) {
        if (this.state.blendFunc.src === src && this.state.blendFunc.dst === dst && this.state.blendFunc.srcAlpha === srcAlpha && this.state.blendFunc.dstAlpha === dstAlpha) return;
        this.state.blendFunc.src = src;
        this.state.blendFunc.dst = dst;
        this.state.blendFunc.srcAlpha = srcAlpha;
        this.state.blendFunc.dstAlpha = dstAlpha;
        if (srcAlpha !== undefined) this.gl.blendFuncSeparate(src, dst, srcAlpha, dstAlpha);
        else this.gl.blendFunc(src, dst);
    }
    setBlendEquation(modeRGB, modeAlpha) {
        modeRGB = modeRGB || this.gl.FUNC_ADD;
        if (this.state.blendEquation.modeRGB === modeRGB && this.state.blendEquation.modeAlpha === modeAlpha) return;
        this.state.blendEquation.modeRGB = modeRGB;
        this.state.blendEquation.modeAlpha = modeAlpha;
        if (modeAlpha !== undefined) this.gl.blendEquationSeparate(modeRGB, modeAlpha);
        else this.gl.blendEquation(modeRGB);
    }
    setCullFace(value) {
        if (this.state.cullFace === value) return;
        this.state.cullFace = value;
        this.gl.cullFace(value);
    }
    setFrontFace(value) {
        if (this.state.frontFace === value) return;
        this.state.frontFace = value;
        this.gl.frontFace(value);
    }
    setDepthMask(value) {
        if (this.state.depthMask === value) return;
        this.state.depthMask = value;
        this.gl.depthMask(value);
    }
    setDepthFunc(value) {
        if (this.state.depthFunc === value) return;
        this.state.depthFunc = value;
        this.gl.depthFunc(value);
    }
    activeTexture(value) {
        if (this.state.activeTextureUnit === value) return;
        this.state.activeTextureUnit = value;
        this.gl.activeTexture(this.gl.TEXTURE0 + value);
    }
    bindFramebuffer({ target: target = this.gl.FRAMEBUFFER, buffer: buffer = null } = {}) {
        if (this.state.framebuffer === buffer) return;
        this.state.framebuffer = buffer;
        this.gl.bindFramebuffer(target, buffer);
    }
    getExtension(extension, webgl2Func, extFunc) {
        // if webgl2 function supported, return func bound to gl context
        if (webgl2Func && this.gl[webgl2Func]) return this.gl[webgl2Func].bind(this.gl);
        // fetch extension once only
        if (!this.extensions[extension]) this.extensions[extension] = this.gl.getExtension(extension);
        // return extension if no function requested
        if (!webgl2Func) return this.extensions[extension];
        // Return null if extension not supported
        if (!this.extensions[extension]) return null;
        // return extension function, bound to extension
        return this.extensions[extension][extFunc].bind(this.extensions[extension]);
    }
    sortOpaque(a, b) {
        if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
        else if (a.program.id !== b.program.id) return a.program.id - b.program.id;
        else if (a.zDepth !== b.zDepth) return a.zDepth - b.zDepth;
        else return b.id - a.id;
    }
    sortTransparent(a, b) {
        if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
        if (a.zDepth !== b.zDepth) return b.zDepth - a.zDepth;
        else return b.id - a.id;
    }
    sortUI(a, b) {
        if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
        else if (a.program.id !== b.program.id) return a.program.id - b.program.id;
        else return b.id - a.id;
    }
    getRenderList({ scene: scene, camera: camera, frustumCull: frustumCull, sort: sort }) {
        let renderList = [];
        if (camera && frustumCull) camera.updateFrustum();
        // Get visible
        scene.traverse((node)=>{
            if (!node.visible) return true;
            if (!node.draw) return;
            if (frustumCull && node.frustumCulled && camera) {
                if (!camera.frustumIntersectsMesh(node)) return;
            }
            renderList.push(node);
        });
        if (sort) {
            const opaque = [];
            const transparent = []; // depthTest true
            const ui = []; // depthTest false
            renderList.forEach((node)=>{
                // Split into the 3 render groups
                if (!node.program.transparent) opaque.push(node);
                else if (node.program.depthTest) transparent.push(node);
                else ui.push(node);
                node.zDepth = 0;
                // Only calculate z-depth if renderOrder unset and depthTest is true
                if (node.renderOrder !== 0 || !node.program.depthTest || !camera) return;
                // update z-depth
                node.worldMatrix.getTranslation($b5a73110aaf50409$var$tempVec3);
                $b5a73110aaf50409$var$tempVec3.applyMatrix4(camera.projectionViewMatrix);
                node.zDepth = $b5a73110aaf50409$var$tempVec3.z;
            });
            opaque.sort(this.sortOpaque);
            transparent.sort(this.sortTransparent);
            ui.sort(this.sortUI);
            renderList = opaque.concat(transparent, ui);
        }
        return renderList;
    }
    render({ scene: scene, camera: camera, target: target = null, update: update = true, sort: sort = true, frustumCull: frustumCull = true, clear: clear }) {
        if (target === null) {
            // make sure no render target bound so draws to canvas
            this.bindFramebuffer();
            this.setViewport(this.width * this.dpr, this.height * this.dpr);
        } else {
            // bind supplied render target and update viewport
            this.bindFramebuffer(target);
            this.setViewport(target.width, target.height);
        }
        if (clear || this.autoClear && clear !== false) {
            // Ensure depth buffer writing is enabled so it can be cleared
            if (this.depth && (!target || target.depth)) {
                this.enable(this.gl.DEPTH_TEST);
                this.setDepthMask(true);
            }
            this.gl.clear((this.color ? this.gl.COLOR_BUFFER_BIT : 0) | (this.depth ? this.gl.DEPTH_BUFFER_BIT : 0) | (this.stencil ? this.gl.STENCIL_BUFFER_BIT : 0));
        }
        // updates all scene graph matrices
        if (update) scene.updateMatrixWorld();
        // Update camera separately, in case not in scene graph
        if (camera) camera.updateMatrixWorld();
        // Get render list - entails culling and sorting
        const renderList = this.getRenderList({
            scene: scene,
            camera: camera,
            frustumCull: frustumCull,
            sort: sort
        });
        renderList.forEach((node)=>{
            node.draw({
                camera: camera
            });
        });
    }
}

const $3fe3a0560092e414$var$EPSILON = 0.000001;
function $3fe3a0560092e414$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $3fe3a0560092e414$export$adaa4cf7ef1b65be(out, x, y) {
    out[0] = x;
    out[1] = y;
    return out;
}
function $3fe3a0560092e414$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    return out;
}
function $3fe3a0560092e414$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    return out;
}
function $3fe3a0560092e414$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    return out;
}
function $3fe3a0560092e414$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    return out;
}
function $3fe3a0560092e414$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    return out;
}
function $3fe3a0560092e414$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return Math.sqrt(x * x + y * y);
}
function $3fe3a0560092e414$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return x * x + y * y;
}
function $3fe3a0560092e414$export$f24224f1c91d8156(a) {
    var x = a[0], y = a[1];
    return Math.sqrt(x * x + y * y);
}
function $3fe3a0560092e414$export$ab44e1323ffc8376(a) {
    var x = a[0], y = a[1];
    return x * x + y * y;
}
function $3fe3a0560092e414$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    return out;
}
function $3fe3a0560092e414$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    return out;
}
function $3fe3a0560092e414$export$a3295358bff77e(out, a) {
    var x = a[0], y = a[1];
    var len = x * x + y * y;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    return out;
}
function $3fe3a0560092e414$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1];
}
function $3fe3a0560092e414$export$bb646b20bb93d339(a, b) {
    return a[0] * b[1] - a[1] * b[0];
}
function $3fe3a0560092e414$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0], ay = a[1];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    return out;
}
function $3fe3a0560092e414$export$b732428d73874bfc(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y;
    out[1] = m[1] * x + m[3] * y;
    return out;
}
function $3fe3a0560092e414$export$3e55bc4b3707dfd3(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $3fe3a0560092e414$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[3] * y + m[6];
    out[1] = m[1] * x + m[4] * y + m[7];
    return out;
}
function $3fe3a0560092e414$export$5ffbd13800309d59(out, a, m) {
    let x = a[0];
    let y = a[1];
    out[0] = m[0] * x + m[4] * y + m[12];
    out[1] = m[1] * x + m[5] * y + m[13];
    return out;
}
function $3fe3a0560092e414$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1];
}


class $fa4ed4f88e886272$export$ac4bca90992eed1 extends Array {
    constructor(x = 0, y = x){
        super(x, y);
        return this;
    }
    get x() {
        return this[0];
    }
    get y() {
        return this[1];
    }
    set x(v) {
        this[0] = v;
    }
    set y(v) {
        this[1] = v;
    }
    set(x, y = x) {
        if (x.length) return this.copy(x);
        $3fe3a0560092e414$export$adaa4cf7ef1b65be(this, x, y);
        return this;
    }
    copy(v) {
        $3fe3a0560092e414$export$784d13d8ee351f07(this, v);
        return this;
    }
    add(va, vb) {
        if (vb) $3fe3a0560092e414$export$e16d8520af44a096(this, va, vb);
        else $3fe3a0560092e414$export$e16d8520af44a096(this, this, va);
        return this;
    }
    sub(va, vb) {
        if (vb) $3fe3a0560092e414$export$4e2d2ead65e5f7e3(this, va, vb);
        else $3fe3a0560092e414$export$4e2d2ead65e5f7e3(this, this, va);
        return this;
    }
    multiply(v) {
        if (v.length) $3fe3a0560092e414$export$2060d2db72cce88f(this, this, v);
        else $3fe3a0560092e414$export$dcdf75081b88279d(this, this, v);
        return this;
    }
    divide(v) {
        if (v.length) $3fe3a0560092e414$export$cd007d971a5a2143(this, this, v);
        else $3fe3a0560092e414$export$dcdf75081b88279d(this, this, 1 / v);
        return this;
    }
    inverse(v = this) {
        $3fe3a0560092e414$export$70ae2c07e401031b(this, v);
        return this;
    }
    // Can't use 'length' as Array.prototype uses it
    len() {
        return $3fe3a0560092e414$export$f24224f1c91d8156(this);
    }
    distance(v) {
        if (v) return $3fe3a0560092e414$export$9f17032d917177de(this, v);
        else return $3fe3a0560092e414$export$f24224f1c91d8156(this);
    }
    squaredLen() {
        return this.squaredDistance();
    }
    squaredDistance(v) {
        if (v) return $3fe3a0560092e414$export$88e6ebb4fe54f538(this, v);
        else return $3fe3a0560092e414$export$ab44e1323ffc8376(this);
    }
    negate(v = this) {
        $3fe3a0560092e414$export$aef51622e549b8b0(this, v);
        return this;
    }
    cross(va, vb) {
        if (vb) return $3fe3a0560092e414$export$bb646b20bb93d339(va, vb);
        return $3fe3a0560092e414$export$bb646b20bb93d339(this, va);
    }
    scale(v) {
        $3fe3a0560092e414$export$dcdf75081b88279d(this, this, v);
        return this;
    }
    normalize() {
        $3fe3a0560092e414$export$a3295358bff77e(this, this);
        return this;
    }
    dot(v) {
        return $3fe3a0560092e414$export$94132a0e348806d4(this, v);
    }
    equals(v) {
        return $3fe3a0560092e414$export$f2599a5cf1109d8(this, v);
    }
    applyMatrix3(mat3) {
        $3fe3a0560092e414$export$f0bfa0a0024626ee(this, this, mat3);
        return this;
    }
    applyMatrix4(mat4) {
        $3fe3a0560092e414$export$5ffbd13800309d59(this, this, mat4);
        return this;
    }
    lerp(v, a) {
        $3fe3a0560092e414$export$3a89f8d6f6bf6c9f(this, this, v, a);
        return this;
    }
    clone() {
        return new $fa4ed4f88e886272$export$ac4bca90992eed1(this[0], this[1]);
    }
    fromArray(a, o = 0) {
        this[0] = a[o];
        this[1] = a[o + 1];
        return this;
    }
    toArray(a = [], o = 0) {
        a[o] = this[0];
        a[o + 1] = this[1];
        return a;
    }
}


// Define the AssetManifest interface
const $b97a95975d4239c9$export$ddcfe69e617489c7 = new Image();
function $b97a95975d4239c9$export$8657d32331889d65(manifest) {
    return new Promise((resolve, reject)=>{
        let loadedAssets = {};
        for (let [imageResourceName, imageURL] of Object.entries(manifest)){
            const image = new Image();
            image.src = imageURL.href;
            image.onload = ()=>{
                loadedAssets[imageResourceName] = image;
                attemptFinishLoading();
            };
            image.onerror = ()=>{
                loadedAssets[imageResourceName] = $b97a95975d4239c9$export$ddcfe69e617489c7;
                attemptFinishLoading();
            };
        }
        function attemptFinishLoading() {
            const hasLoadedAll = Object.keys(manifest).length === Object.keys(loadedAssets).length;
            if (hasLoadedAll) resolve(loadedAssets);
        }
    });
}



const $f18166a0e0295852$var$EPSILON = 0.000001;
function $f18166a0e0295852$export$b4ad467060d346fe(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[4];
    out[4] = a[5];
    out[5] = a[6];
    out[6] = a[8];
    out[7] = a[9];
    out[8] = a[10];
    return out;
}
function $f18166a0e0295852$export$2ff2bbe382249af7(out, q) {
    let x = q[0], y = q[1], z = q[2], w = q[3];
    let x2 = x + x;
    let y2 = y + y;
    let z2 = z + z;
    let xx = x * x2;
    let yx = y * x2;
    let yy = y * y2;
    let zx = z * x2;
    let zy = z * y2;
    let zz = z * z2;
    let wx = w * x2;
    let wy = w * y2;
    let wz = w * z2;
    out[0] = 1 - yy - zz;
    out[3] = yx - wz;
    out[6] = zx + wy;
    out[1] = yx + wz;
    out[4] = 1 - xx - zz;
    out[7] = zy - wx;
    out[2] = zx - wy;
    out[5] = zy + wx;
    out[8] = 1 - xx - yy;
    return out;
}
function $f18166a0e0295852$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $f18166a0e0295852$export$adaa4cf7ef1b65be(out, m00, m01, m02, m10, m11, m12, m20, m21, m22) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m10;
    out[4] = m11;
    out[5] = m12;
    out[6] = m20;
    out[7] = m21;
    out[8] = m22;
    return out;
}
function $f18166a0e0295852$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $f18166a0e0295852$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        let a01 = a[1], a02 = a[2], a12 = a[5];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a01;
        out[5] = a[7];
        out[6] = a02;
        out[7] = a12;
    } else {
        out[0] = a[0];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a[1];
        out[4] = a[4];
        out[5] = a[7];
        out[6] = a[2];
        out[7] = a[5];
        out[8] = a[8];
    }
    return out;
}
function $f18166a0e0295852$export$6897c284b6f9f4dc(out, a) {
    let a00 = a[0], a01 = a[1], a02 = a[2];
    let a10 = a[3], a11 = a[4], a12 = a[5];
    let a20 = a[6], a21 = a[7], a22 = a[8];
    let b01 = a22 * a11 - a12 * a21;
    let b11 = -a22 * a10 + a12 * a20;
    let b21 = a21 * a10 - a11 * a20;
    // Calculate the determinant
    let det = a00 * b01 + a01 * b11 + a02 * b21;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = b01 * det;
    out[1] = (-a22 * a01 + a02 * a21) * det;
    out[2] = (a12 * a01 - a02 * a11) * det;
    out[3] = b11 * det;
    out[4] = (a22 * a00 - a02 * a20) * det;
    out[5] = (-a12 * a00 + a02 * a10) * det;
    out[6] = b21 * det;
    out[7] = (-a21 * a00 + a01 * a20) * det;
    out[8] = (a11 * a00 - a01 * a10) * det;
    return out;
}
function $f18166a0e0295852$export$a04698f914c55ed9(a) {
    let a00 = a[0], a01 = a[1], a02 = a[2];
    let a10 = a[3], a11 = a[4], a12 = a[5];
    let a20 = a[6], a21 = a[7], a22 = a[8];
    return a00 * (a22 * a11 - a12 * a21) + a01 * (-a22 * a10 + a12 * a20) + a02 * (a21 * a10 - a11 * a20);
}
function $f18166a0e0295852$export$2060d2db72cce88f(out, a, b) {
    let a00 = a[0], a01 = a[1], a02 = a[2];
    let a10 = a[3], a11 = a[4], a12 = a[5];
    let a20 = a[6], a21 = a[7], a22 = a[8];
    let b00 = b[0], b01 = b[1], b02 = b[2];
    let b10 = b[3], b11 = b[4], b12 = b[5];
    let b20 = b[6], b21 = b[7], b22 = b[8];
    out[0] = b00 * a00 + b01 * a10 + b02 * a20;
    out[1] = b00 * a01 + b01 * a11 + b02 * a21;
    out[2] = b00 * a02 + b01 * a12 + b02 * a22;
    out[3] = b10 * a00 + b11 * a10 + b12 * a20;
    out[4] = b10 * a01 + b11 * a11 + b12 * a21;
    out[5] = b10 * a02 + b11 * a12 + b12 * a22;
    out[6] = b20 * a00 + b21 * a10 + b22 * a20;
    out[7] = b20 * a01 + b21 * a11 + b22 * a21;
    out[8] = b20 * a02 + b21 * a12 + b22 * a22;
    return out;
}
function $f18166a0e0295852$export$d73ee8ef04f5226a(out, a, v) {
    let a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], x = v[0], y = v[1];
    out[0] = a00;
    out[1] = a01;
    out[2] = a02;
    out[3] = a10;
    out[4] = a11;
    out[5] = a12;
    out[6] = x * a00 + y * a10 + a20;
    out[7] = x * a01 + y * a11 + a21;
    out[8] = x * a02 + y * a12 + a22;
    return out;
}
function $f18166a0e0295852$export$bb628a54ab399bc9(out, a, rad) {
    let a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c * a00 + s * a10;
    out[1] = c * a01 + s * a11;
    out[2] = c * a02 + s * a12;
    out[3] = c * a10 - s * a00;
    out[4] = c * a11 - s * a01;
    out[5] = c * a12 - s * a02;
    out[6] = a20;
    out[7] = a21;
    out[8] = a22;
    return out;
}
function $f18166a0e0295852$export$dcdf75081b88279d(out, a, v) {
    let x = v[0], y = v[1];
    out[0] = x * a[0];
    out[1] = x * a[1];
    out[2] = x * a[2];
    out[3] = y * a[3];
    out[4] = y * a[4];
    out[5] = y * a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $f18166a0e0295852$export$966b25ab6dc1b1f9(out, a) {
    let a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    let a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    let a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    let a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    let b00 = a00 * a11 - a01 * a10;
    let b01 = a00 * a12 - a02 * a10;
    let b02 = a00 * a13 - a03 * a10;
    let b03 = a01 * a12 - a02 * a11;
    let b04 = a01 * a13 - a03 * a11;
    let b05 = a02 * a13 - a03 * a12;
    let b06 = a20 * a31 - a21 * a30;
    let b07 = a20 * a32 - a22 * a30;
    let b08 = a20 * a33 - a23 * a30;
    let b09 = a21 * a32 - a22 * a31;
    let b10 = a21 * a33 - a23 * a31;
    let b11 = a22 * a33 - a23 * a32;
    // Calculate the determinant
    let det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[2] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[3] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[4] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[5] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[6] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[7] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[8] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    return out;
}
function $f18166a0e0295852$export$b74061472fe7c07(out, width, height) {
    out[0] = 2 / width;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = -2 / height;
    out[5] = 0;
    out[6] = -1;
    out[7] = 1;
    out[8] = 1;
    return out;
}
function $f18166a0e0295852$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    return out;
}
function $f18166a0e0295852$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    return out;
}
function $f18166a0e0295852$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    return out;
}


class $5195651babd91a92$export$83f4edd572c84121 extends Array {
    constructor(m00 = 1, m01 = 0, m02 = 0, m10 = 0, m11 = 1, m12 = 0, m20 = 0, m21 = 0, m22 = 1){
        super(m00, m01, m02, m10, m11, m12, m20, m21, m22);
        return this;
    }
    set(m00, m01, m02, m10, m11, m12, m20, m21, m22) {
        if (m00.length) return this.copy(m00);
        $f18166a0e0295852$export$adaa4cf7ef1b65be(this, m00, m01, m02, m10, m11, m12, m20, m21, m22);
        return this;
    }
    translate(v, m = this) {
        $f18166a0e0295852$export$d73ee8ef04f5226a(this, m, v);
        return this;
    }
    rotate(v, m = this) {
        $f18166a0e0295852$export$bb628a54ab399bc9(this, m, v);
        return this;
    }
    scale(v, m = this) {
        $f18166a0e0295852$export$dcdf75081b88279d(this, m, v);
        return this;
    }
    multiply(ma, mb) {
        if (mb) $f18166a0e0295852$export$2060d2db72cce88f(this, ma, mb);
        else $f18166a0e0295852$export$2060d2db72cce88f(this, this, ma);
        return this;
    }
    identity() {
        $f18166a0e0295852$export$f0954fd7d5368655(this);
        return this;
    }
    copy(m) {
        $f18166a0e0295852$export$784d13d8ee351f07(this, m);
        return this;
    }
    fromMatrix4(m) {
        $f18166a0e0295852$export$b4ad467060d346fe(this, m);
        return this;
    }
    fromQuaternion(q) {
        $f18166a0e0295852$export$2ff2bbe382249af7(this, q);
        return this;
    }
    fromBasis(vec3a, vec3b, vec3c) {
        this.set(vec3a[0], vec3a[1], vec3a[2], vec3b[0], vec3b[1], vec3b[2], vec3c[0], vec3c[1], vec3c[2]);
        return this;
    }
    inverse(m = this) {
        $f18166a0e0295852$export$6897c284b6f9f4dc(this, m);
        return this;
    }
    getNormalMatrix(m) {
        $f18166a0e0295852$export$966b25ab6dc1b1f9(this, m);
        return this;
    }
}



let $81280ac60efc3984$var$ID = 0;
class $81280ac60efc3984$export$e176487c05830cc5 extends (0, $b99754c4edbe0b63$export$563a914cafbdc389) {
    constructor(gl, { geometry: geometry, program: program, mode: mode = gl.TRIANGLES, frustumCulled: frustumCulled = true, renderOrder: renderOrder = 0 } = {}){
        super();
        if (!gl.canvas) console.error("gl not passed as first argument to Mesh");
        this.gl = gl;
        this.id = $81280ac60efc3984$var$ID++;
        this.geometry = geometry;
        this.program = program;
        this.mode = mode;
        // Used to skip frustum culling
        this.frustumCulled = frustumCulled;
        // Override sorting to force an order
        this.renderOrder = renderOrder;
        this.modelViewMatrix = new (0, $4e21c701cd686be1$export$21c0e3d5e995d7e1)();
        this.normalMatrix = new (0, $5195651babd91a92$export$83f4edd572c84121)();
        this.beforeRenderCallbacks = [];
        this.afterRenderCallbacks = [];
    }
    onBeforeRender(f) {
        this.beforeRenderCallbacks.push(f);
        return this;
    }
    onAfterRender(f) {
        this.afterRenderCallbacks.push(f);
        return this;
    }
    draw({ camera: camera } = {}) {
        if (camera) {
            // Add empty matrix uniforms to program if unset
            if (!this.program.uniforms.modelMatrix) Object.assign(this.program.uniforms, {
                modelMatrix: {
                    value: null
                },
                viewMatrix: {
                    value: null
                },
                modelViewMatrix: {
                    value: null
                },
                normalMatrix: {
                    value: null
                },
                projectionMatrix: {
                    value: null
                },
                cameraPosition: {
                    value: null
                }
            });
            // Set the matrix uniforms
            this.program.uniforms.projectionMatrix.value = camera.projectionMatrix;
            this.program.uniforms.cameraPosition.value = camera.worldPosition;
            this.program.uniforms.viewMatrix.value = camera.viewMatrix;
            this.modelViewMatrix.multiply(camera.viewMatrix, this.worldMatrix);
            this.normalMatrix.getNormalMatrix(this.modelViewMatrix);
            this.program.uniforms.modelMatrix.value = this.worldMatrix;
            this.program.uniforms.modelViewMatrix.value = this.modelViewMatrix;
            this.program.uniforms.normalMatrix.value = this.normalMatrix;
        }
        this.beforeRenderCallbacks.forEach((f)=>f && f({
                mesh: this,
                camera: camera
            }));
        // determine if faces need to be flipped - when mesh scaled negatively
        let flipFaces = this.program.cullFace && this.worldMatrix.determinant() < 0;
        this.program.use({
            flipFaces: flipFaces
        });
        this.geometry.draw({
            mode: this.mode,
            program: this.program
        });
        this.afterRenderCallbacks.forEach((f)=>f && f({
                mesh: this,
                camera: camera
            }));
    }
}

// attribute params
// {
//     data - typed array eg UInt16Array for indices, Float32Array
//     size - int default 1
//     instanced - default null. Pass divisor amount
//     type - gl enum default gl.UNSIGNED_SHORT for 'index', gl.FLOAT for others
//     normalized - boolean default false
//     buffer - gl buffer, if buffer exists, don't need to provide data - although needs position data for bounds calculation
//     stride - default 0 - for when passing in buffer
//     offset - default 0 - for when passing in buffer
//     count - default null - for when passing in buffer
//     min - array - for when passing in buffer
//     max - array - for when passing in buffer
// }
// TODO: fit in transform feedback

const $ba0ac60fd26b90a9$var$tempVec3 = /* @__PURE__ */ new (0, $46d76f993ed555f5$export$838423f3adec30fa)();
let $ba0ac60fd26b90a9$var$ID = 1;
let $ba0ac60fd26b90a9$var$ATTR_ID = 1;
// To stop inifinite warnings
let $ba0ac60fd26b90a9$var$isBoundsWarned = false;
class $ba0ac60fd26b90a9$export$2db6c17465f94a2 {
    constructor(gl, attributes = {}){
        if (!gl.canvas) console.error("gl not passed as first argument to Geometry");
        this.gl = gl;
        this.attributes = attributes;
        this.id = $ba0ac60fd26b90a9$var$ID++;
        // Store one VAO per program attribute locations order
        this.VAOs = {};
        this.drawRange = {
            start: 0,
            count: 0
        };
        this.instancedCount = 0;
        // Unbind current VAO so that new buffers don't get added to active mesh
        this.gl.renderer.bindVertexArray(null);
        this.gl.renderer.currentGeometry = null;
        // Alias for state store to avoid redundant calls for global state
        this.glState = this.gl.renderer.state;
        // create the buffers
        for(let key in attributes)this.addAttribute(key, attributes[key]);
    }
    addAttribute(key, attr) {
        this.attributes[key] = attr;
        // Set options
        attr.id = $ba0ac60fd26b90a9$var$ATTR_ID++; // TODO: currently unused, remove?
        attr.size = attr.size || 1;
        attr.type = attr.type || (attr.data.constructor === Float32Array ? this.gl.FLOAT : attr.data.constructor === Uint16Array ? this.gl.UNSIGNED_SHORT : this.gl.UNSIGNED_INT); // Uint32Array
        attr.target = key === "index" ? this.gl.ELEMENT_ARRAY_BUFFER : this.gl.ARRAY_BUFFER;
        attr.normalized = attr.normalized || false;
        attr.stride = attr.stride || 0;
        attr.offset = attr.offset || 0;
        attr.count = attr.count || (attr.stride ? attr.data.byteLength / attr.stride : attr.data.length / attr.size);
        attr.divisor = attr.instanced || 0;
        attr.needsUpdate = false;
        attr.usage = attr.usage || this.gl.STATIC_DRAW;
        if (!attr.buffer) // Push data to buffer
        this.updateAttribute(attr);
        // Update geometry counts. If indexed, ignore regular attributes
        if (attr.divisor) {
            this.isInstanced = true;
            if (this.instancedCount && this.instancedCount !== attr.count * attr.divisor) {
                console.warn("geometry has multiple instanced buffers of different length");
                return this.instancedCount = Math.min(this.instancedCount, attr.count * attr.divisor);
            }
            this.instancedCount = attr.count * attr.divisor;
        } else if (key === "index") this.drawRange.count = attr.count;
        else if (!this.attributes.index) this.drawRange.count = Math.max(this.drawRange.count, attr.count);
    }
    updateAttribute(attr) {
        const isNewBuffer = !attr.buffer;
        if (isNewBuffer) attr.buffer = this.gl.createBuffer();
        if (this.glState.boundBuffer !== attr.buffer) {
            this.gl.bindBuffer(attr.target, attr.buffer);
            this.glState.boundBuffer = attr.buffer;
        }
        if (isNewBuffer) this.gl.bufferData(attr.target, attr.data, attr.usage);
        else this.gl.bufferSubData(attr.target, 0, attr.data);
        attr.needsUpdate = false;
    }
    setIndex(value) {
        this.addAttribute("index", value);
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    setInstancedCount(value) {
        this.instancedCount = value;
    }
    createVAO(program) {
        this.VAOs[program.attributeOrder] = this.gl.renderer.createVertexArray();
        this.gl.renderer.bindVertexArray(this.VAOs[program.attributeOrder]);
        this.bindAttributes(program);
    }
    bindAttributes(program) {
        // Link all attributes to program using gl.vertexAttribPointer
        program.attributeLocations.forEach((location, { name: name, type: type })=>{
            // If geometry missing a required shader attribute
            if (!this.attributes[name]) {
                console.warn(`active attribute ${name} not being supplied`);
                return;
            }
            const attr = this.attributes[name];
            this.gl.bindBuffer(attr.target, attr.buffer);
            this.glState.boundBuffer = attr.buffer;
            // For matrix attributes, buffer needs to be defined per column
            let numLoc = 1;
            if (type === 35674) numLoc = 2; // mat2
            if (type === 35675) numLoc = 3; // mat3
            if (type === 35676) numLoc = 4; // mat4
            const size = attr.size / numLoc;
            const stride = numLoc === 1 ? 0 : numLoc * numLoc * 4;
            const offset = numLoc === 1 ? 0 : numLoc * 4;
            for(let i = 0; i < numLoc; i++){
                this.gl.vertexAttribPointer(location + i, size, attr.type, attr.normalized, attr.stride + stride, attr.offset + i * offset);
                this.gl.enableVertexAttribArray(location + i);
                // For instanced attributes, divisor needs to be set.
                // For firefox, need to set back to 0 if non-instanced drawn after instanced. Else won't render
                this.gl.renderer.vertexAttribDivisor(location + i, attr.divisor);
            }
        });
        // Bind indices if geometry indexed
        if (this.attributes.index) this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, this.attributes.index.buffer);
    }
    draw({ program: program, mode: mode = this.gl.TRIANGLES }) {
        if (this.gl.renderer.currentGeometry !== `${this.id}_${program.attributeOrder}`) {
            if (!this.VAOs[program.attributeOrder]) this.createVAO(program);
            this.gl.renderer.bindVertexArray(this.VAOs[program.attributeOrder]);
            this.gl.renderer.currentGeometry = `${this.id}_${program.attributeOrder}`;
        }
        // Check if any attributes need updating
        program.attributeLocations.forEach((location, { name: name })=>{
            const attr = this.attributes[name];
            if (attr.needsUpdate) this.updateAttribute(attr);
        });
        // For drawElements, offset needs to be multiple of type size
        let indexBytesPerElement = 2;
        if (this.attributes.index?.type === this.gl.UNSIGNED_INT) indexBytesPerElement = 4;
        if (this.isInstanced) {
            if (this.attributes.index) this.gl.renderer.drawElementsInstanced(mode, this.drawRange.count, this.attributes.index.type, this.attributes.index.offset + this.drawRange.start * indexBytesPerElement, this.instancedCount);
            else this.gl.renderer.drawArraysInstanced(mode, this.drawRange.start, this.drawRange.count, this.instancedCount);
        } else if (this.attributes.index) this.gl.drawElements(mode, this.drawRange.count, this.attributes.index.type, this.attributes.index.offset + this.drawRange.start * indexBytesPerElement);
        else this.gl.drawArrays(mode, this.drawRange.start, this.drawRange.count);
    }
    getPosition() {
        // Use position buffer, or min/max if available
        const attr = this.attributes.position;
        // if (attr.min) return [...attr.min, ...attr.max];
        if (attr.data) return attr;
        if ($ba0ac60fd26b90a9$var$isBoundsWarned) return;
        console.warn("No position buffer data found to compute bounds");
        return $ba0ac60fd26b90a9$var$isBoundsWarned = true;
    }
    computeBoundingBox(attr) {
        if (!attr) attr = this.getPosition();
        const array = attr.data;
        // Data loaded shouldn't haave stride, only buffers
        // const stride = attr.stride ? attr.stride / array.BYTES_PER_ELEMENT : attr.size;
        const stride = attr.size;
        if (!this.bounds) this.bounds = {
            min: new (0, $46d76f993ed555f5$export$838423f3adec30fa)(),
            max: new (0, $46d76f993ed555f5$export$838423f3adec30fa)(),
            center: new (0, $46d76f993ed555f5$export$838423f3adec30fa)(),
            scale: new (0, $46d76f993ed555f5$export$838423f3adec30fa)(),
            radius: Infinity
        };
        const min = this.bounds.min;
        const max = this.bounds.max;
        const center = this.bounds.center;
        const scale = this.bounds.scale;
        min.set(Infinity);
        max.set(-Infinity);
        // TODO: check size of position (eg triangle with Vec2)
        for(let i = 0, l = array.length; i < l; i += stride){
            const x = array[i];
            const y = array[i + 1];
            const z = array[i + 2];
            min.x = Math.min(x, min.x);
            min.y = Math.min(y, min.y);
            min.z = Math.min(z, min.z);
            max.x = Math.max(x, max.x);
            max.y = Math.max(y, max.y);
            max.z = Math.max(z, max.z);
        }
        scale.sub(max, min);
        center.add(min, max).divide(2);
    }
    computeBoundingSphere(attr) {
        if (!attr) attr = this.getPosition();
        const array = attr.data;
        // Data loaded shouldn't haave stride, only buffers
        // const stride = attr.stride ? attr.stride / array.BYTES_PER_ELEMENT : attr.size;
        const stride = attr.size;
        if (!this.bounds) this.computeBoundingBox(attr);
        let maxRadiusSq = 0;
        for(let i = 0, l = array.length; i < l; i += stride){
            $ba0ac60fd26b90a9$var$tempVec3.fromArray(array, i);
            maxRadiusSq = Math.max(maxRadiusSq, this.bounds.center.squaredDistance($ba0ac60fd26b90a9$var$tempVec3));
        }
        this.bounds.radius = Math.sqrt(maxRadiusSq);
    }
    remove() {
        for(let key in this.VAOs){
            this.gl.renderer.deleteVertexArray(this.VAOs[key]);
            delete this.VAOs[key];
        }
        for(let key in this.attributes){
            this.gl.deleteBuffer(this.attributes[key].buffer);
            delete this.attributes[key];
        }
    }
}


class $733fd634af54059e$export$7ff5ac152ef991b0 extends (0, $ba0ac60fd26b90a9$export$2db6c17465f94a2) {
    constructor(gl, { width: width = 1, height: height = 1, widthSegments: widthSegments = 1, heightSegments: heightSegments = 1, attributes: attributes = {} } = {}){
        const wSegs = widthSegments;
        const hSegs = heightSegments;
        // Determine length of arrays
        const num = (wSegs + 1) * (hSegs + 1);
        const numIndices = wSegs * hSegs * 6;
        // Generate empty arrays once
        const position = new Float32Array(num * 3);
        const normal = new Float32Array(num * 3);
        const uv = new Float32Array(num * 2);
        const index = numIndices > 65536 ? new Uint32Array(numIndices) : new Uint16Array(numIndices);
        $733fd634af54059e$export$7ff5ac152ef991b0.buildPlane(position, normal, uv, index, width, height, 0, wSegs, hSegs);
        Object.assign(attributes, {
            position: {
                size: 3,
                data: position
            },
            normal: {
                size: 3,
                data: normal
            },
            uv: {
                size: 2,
                data: uv
            },
            index: {
                data: index
            }
        });
        super(gl, attributes);
    }
    static buildPlane(position, normal, uv, index, width, height, depth, wSegs, hSegs, u = 0, v = 1, w = 2, uDir = 1, vDir = -1, i = 0, ii = 0) {
        const io = i;
        const segW = width / wSegs;
        const segH = height / hSegs;
        for(let iy = 0; iy <= hSegs; iy++){
            let y = iy * segH - height / 2;
            for(let ix = 0; ix <= wSegs; ix++, i++){
                let x = ix * segW - width / 2;
                position[i * 3 + u] = x * uDir;
                position[i * 3 + v] = y * vDir;
                position[i * 3 + w] = depth / 2;
                normal[i * 3 + u] = 0;
                normal[i * 3 + v] = 0;
                normal[i * 3 + w] = depth >= 0 ? 1 : -1;
                uv[i * 2] = ix / wSegs;
                uv[i * 2 + 1] = 1 - iy / hSegs;
                if (iy === hSegs || ix === wSegs) continue;
                let a = io + ix + iy * (wSegs + 1);
                let b = io + ix + (iy + 1) * (wSegs + 1);
                let c = io + ix + (iy + 1) * (wSegs + 1) + 1;
                let d = io + ix + iy * (wSegs + 1) + 1;
                index[ii * 6] = a;
                index[ii * 6 + 1] = b;
                index[ii * 6 + 2] = d;
                index[ii * 6 + 3] = b;
                index[ii * 6 + 4] = c;
                index[ii * 6 + 5] = d;
                ii++;
            }
        }
    }
}

// TODO: upload empty texture if null ? maybe not
// TODO: upload identity matrix if null ?
// TODO: sampler Cube
let $5baeac5adaf115e1$var$ID = 1;
// cache of typed arrays used to flatten uniform arrays
const $5baeac5adaf115e1$var$arrayCacheF32 = {};
class $5baeac5adaf115e1$export$b6c59b989905b650 {
    constructor(gl, { vertex: vertex, fragment: fragment, uniforms: uniforms = {}, transparent: transparent = false, cullFace: cullFace = gl.BACK, frontFace: frontFace = gl.CCW, depthTest: depthTest = true, depthWrite: depthWrite = true, depthFunc: depthFunc = gl.LEQUAL } = {}){
        if (!gl.canvas) console.error("gl not passed as first argument to Program");
        this.gl = gl;
        this.uniforms = uniforms;
        this.id = $5baeac5adaf115e1$var$ID++;
        if (!vertex) console.warn("vertex shader not supplied");
        if (!fragment) console.warn("fragment shader not supplied");
        // Store program state
        this.transparent = transparent;
        this.cullFace = cullFace;
        this.frontFace = frontFace;
        this.depthTest = depthTest;
        this.depthWrite = depthWrite;
        this.depthFunc = depthFunc;
        this.blendFunc = {};
        this.blendEquation = {};
        // set default blendFunc if transparent flagged
        if (this.transparent && !this.blendFunc.src) {
            if (this.gl.renderer.premultipliedAlpha) this.setBlendFunc(this.gl.ONE, this.gl.ONE_MINUS_SRC_ALPHA);
            else this.setBlendFunc(this.gl.SRC_ALPHA, this.gl.ONE_MINUS_SRC_ALPHA);
        }
        // Create empty shaders and attach to program
        this.vertexShader = gl.createShader(gl.VERTEX_SHADER);
        this.fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
        this.program = gl.createProgram();
        gl.attachShader(this.program, this.vertexShader);
        gl.attachShader(this.program, this.fragmentShader);
        // Compile shaders with source
        this.setShaders({
            vertex: vertex,
            fragment: fragment
        });
    }
    setShaders({ vertex: vertex, fragment: fragment }) {
        if (vertex) {
            // compile vertex shader and log errors
            this.gl.shaderSource(this.vertexShader, vertex);
            this.gl.compileShader(this.vertexShader);
            if (this.gl.getShaderInfoLog(this.vertexShader) !== "") console.warn(`${this.gl.getShaderInfoLog(this.vertexShader)}\nVertex Shader\n${$5baeac5adaf115e1$var$addLineNumbers(vertex)}`);
        }
        if (fragment) {
            // compile fragment shader and log errors
            this.gl.shaderSource(this.fragmentShader, fragment);
            this.gl.compileShader(this.fragmentShader);
            if (this.gl.getShaderInfoLog(this.fragmentShader) !== "") console.warn(`${this.gl.getShaderInfoLog(this.fragmentShader)}\nFragment Shader\n${$5baeac5adaf115e1$var$addLineNumbers(fragment)}`);
        }
        // compile program and log errors
        this.gl.linkProgram(this.program);
        if (!this.gl.getProgramParameter(this.program, this.gl.LINK_STATUS)) return console.warn(this.gl.getProgramInfoLog(this.program));
        // Get active uniform locations
        this.uniformLocations = new Map();
        let numUniforms = this.gl.getProgramParameter(this.program, this.gl.ACTIVE_UNIFORMS);
        for(let uIndex = 0; uIndex < numUniforms; uIndex++){
            let uniform = this.gl.getActiveUniform(this.program, uIndex);
            this.uniformLocations.set(uniform, this.gl.getUniformLocation(this.program, uniform.name));
            // split uniforms' names to separate array and struct declarations
            const split = uniform.name.match(/(\w+)/g);
            uniform.uniformName = split[0];
            uniform.nameComponents = split.slice(1);
        }
        // Get active attribute locations
        this.attributeLocations = new Map();
        const locations = [];
        const numAttribs = this.gl.getProgramParameter(this.program, this.gl.ACTIVE_ATTRIBUTES);
        for(let aIndex = 0; aIndex < numAttribs; aIndex++){
            const attribute = this.gl.getActiveAttrib(this.program, aIndex);
            const location = this.gl.getAttribLocation(this.program, attribute.name);
            // Ignore special built-in inputs. eg gl_VertexID, gl_InstanceID
            if (location === -1) continue;
            locations[location] = attribute.name;
            this.attributeLocations.set(attribute, location);
        }
        this.attributeOrder = locations.join("");
    }
    setBlendFunc(src, dst, srcAlpha, dstAlpha) {
        this.blendFunc.src = src;
        this.blendFunc.dst = dst;
        this.blendFunc.srcAlpha = srcAlpha;
        this.blendFunc.dstAlpha = dstAlpha;
        if (src) this.transparent = true;
    }
    setBlendEquation(modeRGB, modeAlpha) {
        this.blendEquation.modeRGB = modeRGB;
        this.blendEquation.modeAlpha = modeAlpha;
    }
    applyState() {
        if (this.depthTest) this.gl.renderer.enable(this.gl.DEPTH_TEST);
        else this.gl.renderer.disable(this.gl.DEPTH_TEST);
        if (this.cullFace) this.gl.renderer.enable(this.gl.CULL_FACE);
        else this.gl.renderer.disable(this.gl.CULL_FACE);
        if (this.blendFunc.src) this.gl.renderer.enable(this.gl.BLEND);
        else this.gl.renderer.disable(this.gl.BLEND);
        if (this.cullFace) this.gl.renderer.setCullFace(this.cullFace);
        this.gl.renderer.setFrontFace(this.frontFace);
        this.gl.renderer.setDepthMask(this.depthWrite);
        this.gl.renderer.setDepthFunc(this.depthFunc);
        if (this.blendFunc.src) this.gl.renderer.setBlendFunc(this.blendFunc.src, this.blendFunc.dst, this.blendFunc.srcAlpha, this.blendFunc.dstAlpha);
        this.gl.renderer.setBlendEquation(this.blendEquation.modeRGB, this.blendEquation.modeAlpha);
    }
    use({ flipFaces: flipFaces = false } = {}) {
        let textureUnit = -1;
        const programActive = this.gl.renderer.state.currentProgram === this.id;
        // Avoid gl call if program already in use
        if (!programActive) {
            this.gl.useProgram(this.program);
            this.gl.renderer.state.currentProgram = this.id;
        }
        // Set only the active uniforms found in the shader
        this.uniformLocations.forEach((location, activeUniform)=>{
            let uniform = this.uniforms[activeUniform.uniformName];
            for (const component of activeUniform.nameComponents){
                if (!uniform) break;
                if (component in uniform) uniform = uniform[component];
                else if (Array.isArray(uniform.value)) break;
                else {
                    uniform = undefined;
                    break;
                }
            }
            if (!uniform) return $5baeac5adaf115e1$var$warn(`Active uniform ${activeUniform.name} has not been supplied`);
            if (uniform && uniform.value === undefined) return $5baeac5adaf115e1$var$warn(`${activeUniform.name} uniform is missing a value parameter`);
            if (uniform.value.texture) {
                textureUnit = textureUnit + 1;
                // Check if texture needs to be updated
                uniform.value.update(textureUnit);
                return $5baeac5adaf115e1$var$setUniform(this.gl, activeUniform.type, location, textureUnit);
            }
            // For texture arrays, set uniform as an array of texture units instead of just one
            if (uniform.value.length && uniform.value[0].texture) {
                const textureUnits = [];
                uniform.value.forEach((value)=>{
                    textureUnit = textureUnit + 1;
                    value.update(textureUnit);
                    textureUnits.push(textureUnit);
                });
                return $5baeac5adaf115e1$var$setUniform(this.gl, activeUniform.type, location, textureUnits);
            }
            $5baeac5adaf115e1$var$setUniform(this.gl, activeUniform.type, location, uniform.value);
        });
        this.applyState();
        if (flipFaces) this.gl.renderer.setFrontFace(this.frontFace === this.gl.CCW ? this.gl.CW : this.gl.CCW);
    }
    remove() {
        this.gl.deleteProgram(this.program);
    }
}
function $5baeac5adaf115e1$var$setUniform(gl, type, location, value) {
    value = value.length ? $5baeac5adaf115e1$var$flatten(value) : value;
    const setValue = gl.renderer.state.uniformLocations.get(location);
    // Avoid redundant uniform commands
    if (value.length) {
        if (setValue === undefined || setValue.length !== value.length) // clone array to store as cache
        gl.renderer.state.uniformLocations.set(location, value.slice(0));
        else {
            if ($5baeac5adaf115e1$var$arraysEqual(setValue, value)) return;
            // Update cached array values
            setValue.set ? setValue.set(value) : $5baeac5adaf115e1$var$setArray(setValue, value);
            gl.renderer.state.uniformLocations.set(location, setValue);
        }
    } else {
        if (setValue === value) return;
        gl.renderer.state.uniformLocations.set(location, value);
    }
    switch(type){
        case 5126:
            return value.length ? gl.uniform1fv(location, value) : gl.uniform1f(location, value); // FLOAT
        case 35664:
            return gl.uniform2fv(location, value); // FLOAT_VEC2
        case 35665:
            return gl.uniform3fv(location, value); // FLOAT_VEC3
        case 35666:
            return gl.uniform4fv(location, value); // FLOAT_VEC4
        case 35670:
        case 5124:
        case 35678:
        case 36306:
        case 35680:
            return value.length ? gl.uniform1iv(location, value) : gl.uniform1i(location, value); // SAMPLER_CUBE
        case 35671:
        case 35667:
            return gl.uniform2iv(location, value); // INT_VEC2
        case 35672:
        case 35668:
            return gl.uniform3iv(location, value); // INT_VEC3
        case 35673:
        case 35669:
            return gl.uniform4iv(location, value); // INT_VEC4
        case 35674:
            return gl.uniformMatrix2fv(location, false, value); // FLOAT_MAT2
        case 35675:
            return gl.uniformMatrix3fv(location, false, value); // FLOAT_MAT3
        case 35676:
            return gl.uniformMatrix4fv(location, false, value); // FLOAT_MAT4
    }
}
function $5baeac5adaf115e1$var$addLineNumbers(string) {
    let lines = string.split("\n");
    for(let i = 0; i < lines.length; i++)lines[i] = i + 1 + ": " + lines[i];
    return lines.join("\n");
}
function $5baeac5adaf115e1$var$flatten(a) {
    const arrayLen = a.length;
    const valueLen = a[0].length;
    if (valueLen === undefined) return a;
    const length = arrayLen * valueLen;
    let value = $5baeac5adaf115e1$var$arrayCacheF32[length];
    if (!value) $5baeac5adaf115e1$var$arrayCacheF32[length] = value = new Float32Array(length);
    for(let i = 0; i < arrayLen; i++)value.set(a[i], i * valueLen);
    return value;
}
function $5baeac5adaf115e1$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $5baeac5adaf115e1$var$setArray(a, b) {
    for(let i = 0, l = a.length; i < l; i++)a[i] = b[i];
}
let $5baeac5adaf115e1$var$warnCount = 0;
function $5baeac5adaf115e1$var$warn(message) {
    if ($5baeac5adaf115e1$var$warnCount > 100) return;
    console.warn(message);
    $5baeac5adaf115e1$var$warnCount++;
    if ($5baeac5adaf115e1$var$warnCount > 100) console.warn("More than 100 program warnings - stopping logs.");
}

// TODO: barycentric code shouldn't be here, but where?
// TODO: SphereCast?



const $7e9178712a9372f4$var$tempVec2a = /* @__PURE__ */ new (0, $fa4ed4f88e886272$export$ac4bca90992eed1)();
const $7e9178712a9372f4$var$tempVec2b = /* @__PURE__ */ new (0, $fa4ed4f88e886272$export$ac4bca90992eed1)();
const $7e9178712a9372f4$var$tempVec2c = /* @__PURE__ */ new (0, $fa4ed4f88e886272$export$ac4bca90992eed1)();
const $7e9178712a9372f4$var$tempVec3a = /* @__PURE__ */ new (0, $46d76f993ed555f5$export$838423f3adec30fa)();
const $7e9178712a9372f4$var$tempVec3b = /* @__PURE__ */ new (0, $46d76f993ed555f5$export$838423f3adec30fa)();
const $7e9178712a9372f4$var$tempVec3c = /* @__PURE__ */ new (0, $46d76f993ed555f5$export$838423f3adec30fa)();
const $7e9178712a9372f4$var$tempVec3d = /* @__PURE__ */ new (0, $46d76f993ed555f5$export$838423f3adec30fa)();
const $7e9178712a9372f4$var$tempVec3e = /* @__PURE__ */ new (0, $46d76f993ed555f5$export$838423f3adec30fa)();
const $7e9178712a9372f4$var$tempVec3f = /* @__PURE__ */ new (0, $46d76f993ed555f5$export$838423f3adec30fa)();
const $7e9178712a9372f4$var$tempVec3g = /* @__PURE__ */ new (0, $46d76f993ed555f5$export$838423f3adec30fa)();
const $7e9178712a9372f4$var$tempVec3h = /* @__PURE__ */ new (0, $46d76f993ed555f5$export$838423f3adec30fa)();
const $7e9178712a9372f4$var$tempVec3i = /* @__PURE__ */ new (0, $46d76f993ed555f5$export$838423f3adec30fa)();
const $7e9178712a9372f4$var$tempVec3j = /* @__PURE__ */ new (0, $46d76f993ed555f5$export$838423f3adec30fa)();
const $7e9178712a9372f4$var$tempVec3k = /* @__PURE__ */ new (0, $46d76f993ed555f5$export$838423f3adec30fa)();
const $7e9178712a9372f4$var$tempMat4 = /* @__PURE__ */ new (0, $4e21c701cd686be1$export$21c0e3d5e995d7e1)();
class $7e9178712a9372f4$export$ff2d1de6a335cd2e {
    constructor(){
        this.origin = new (0, $46d76f993ed555f5$export$838423f3adec30fa)();
        this.direction = new (0, $46d76f993ed555f5$export$838423f3adec30fa)();
    }
    // Set ray from mouse unprojection
    castMouse(camera, mouse = [
        0,
        0
    ]) {
        if (camera.type === "orthographic") {
            // Set origin
            // Since camera is orthographic, origin is not the camera position
            const { left: left, right: right, bottom: bottom, top: top, zoom: zoom } = camera;
            const x = left / zoom + (right - left) / zoom * (mouse[0] * 0.5 + 0.5);
            const y = bottom / zoom + (top - bottom) / zoom * (mouse[1] * 0.5 + 0.5);
            this.origin.set(x, y, 0);
            this.origin.applyMatrix4(camera.worldMatrix);
            // Set direction
            // https://community.khronos.org/t/get-direction-from-transformation-matrix-or-quat/65502/2
            this.direction.x = -camera.worldMatrix[8];
            this.direction.y = -camera.worldMatrix[9];
            this.direction.z = -camera.worldMatrix[10];
        } else {
            // Set origin
            camera.worldMatrix.getTranslation(this.origin);
            // Set direction
            this.direction.set(mouse[0], mouse[1], 0.5);
            camera.unproject(this.direction);
            this.direction.sub(this.origin).normalize();
        }
    }
    intersectBounds(meshes, { maxDistance: maxDistance, output: output = [] } = {}) {
        if (!Array.isArray(meshes)) meshes = [
            meshes
        ];
        const invWorldMat4 = $7e9178712a9372f4$var$tempMat4;
        const origin = $7e9178712a9372f4$var$tempVec3a;
        const direction = $7e9178712a9372f4$var$tempVec3b;
        const hits = output;
        hits.length = 0;
        meshes.forEach((mesh)=>{
            // Create bounds
            if (!mesh.geometry.bounds || mesh.geometry.bounds.radius === Infinity) mesh.geometry.computeBoundingSphere();
            const bounds = mesh.geometry.bounds;
            invWorldMat4.inverse(mesh.worldMatrix);
            // Get max distance locally
            let localMaxDistance;
            if (maxDistance) {
                direction.copy(this.direction).scaleRotateMatrix4(invWorldMat4);
                localMaxDistance = maxDistance * direction.len();
            }
            // Take world space ray and make it object space to align with bounding box
            origin.copy(this.origin).applyMatrix4(invWorldMat4);
            direction.copy(this.direction).transformDirection(invWorldMat4);
            // Break out early if bounds too far away from origin
            if (maxDistance) {
                if (origin.distance(bounds.center) - bounds.radius > localMaxDistance) return;
            }
            let localDistance = 0;
            // Check origin isn't inside bounds before testing intersection
            if (mesh.geometry.raycast === "sphere") {
                if (origin.distance(bounds.center) > bounds.radius) {
                    localDistance = this.intersectSphere(bounds, origin, direction);
                    if (!localDistance) return;
                }
            } else if (origin.x < bounds.min.x || origin.x > bounds.max.x || origin.y < bounds.min.y || origin.y > bounds.max.y || origin.z < bounds.min.z || origin.z > bounds.max.z) {
                localDistance = this.intersectBox(bounds, origin, direction);
                if (!localDistance) return;
            }
            if (maxDistance && localDistance > localMaxDistance) return;
            // Create object on mesh to avoid generating lots of objects
            if (!mesh.hit) mesh.hit = {
                localPoint: new (0, $46d76f993ed555f5$export$838423f3adec30fa)(),
                point: new (0, $46d76f993ed555f5$export$838423f3adec30fa)()
            };
            mesh.hit.localPoint.copy(direction).multiply(localDistance).add(origin);
            mesh.hit.point.copy(mesh.hit.localPoint).applyMatrix4(mesh.worldMatrix);
            mesh.hit.distance = mesh.hit.point.distance(this.origin);
            hits.push(mesh);
        });
        hits.sort((a, b)=>a.hit.distance - b.hit.distance);
        return hits;
    }
    intersectMeshes(meshes, { cullFace: cullFace = true, maxDistance: maxDistance, includeUV: includeUV = true, includeNormal: includeNormal = true, output: output = [] } = {}) {
        // Test bounds first before testing geometry
        const hits = this.intersectBounds(meshes, {
            maxDistance: maxDistance,
            output: output
        });
        if (!hits.length) return hits;
        const invWorldMat4 = $7e9178712a9372f4$var$tempMat4;
        const origin = $7e9178712a9372f4$var$tempVec3a;
        const direction = $7e9178712a9372f4$var$tempVec3b;
        const a = $7e9178712a9372f4$var$tempVec3c;
        const b = $7e9178712a9372f4$var$tempVec3d;
        const c = $7e9178712a9372f4$var$tempVec3e;
        const closestFaceNormal = $7e9178712a9372f4$var$tempVec3f;
        const faceNormal = $7e9178712a9372f4$var$tempVec3g;
        const barycoord = $7e9178712a9372f4$var$tempVec3h;
        const uvA = $7e9178712a9372f4$var$tempVec2a;
        const uvB = $7e9178712a9372f4$var$tempVec2b;
        const uvC = $7e9178712a9372f4$var$tempVec2c;
        for(let i = hits.length - 1; i >= 0; i--){
            const mesh = hits[i];
            invWorldMat4.inverse(mesh.worldMatrix);
            // Get max distance locally
            let localMaxDistance;
            if (maxDistance) {
                direction.copy(this.direction).scaleRotateMatrix4(invWorldMat4);
                localMaxDistance = maxDistance * direction.len();
            }
            // Take world space ray and make it object space to align with bounding box
            origin.copy(this.origin).applyMatrix4(invWorldMat4);
            direction.copy(this.direction).transformDirection(invWorldMat4);
            let localDistance = 0;
            let closestA, closestB, closestC;
            const geometry = mesh.geometry;
            const attributes = geometry.attributes;
            const index = attributes.index;
            const position = attributes.position;
            const start = Math.max(0, geometry.drawRange.start);
            const end = Math.min(index ? index.count : position.count, geometry.drawRange.start + geometry.drawRange.count);
            // Data loaded shouldn't haave stride, only buffers
            // const stride = position.stride ? position.stride / position.data.BYTES_PER_ELEMENT : position.size;
            const stride = position.size;
            for(let j = start; j < end; j += 3){
                // Position attribute indices for each triangle
                const ai = index ? index.data[j] : j;
                const bi = index ? index.data[j + 1] : j + 1;
                const ci = index ? index.data[j + 2] : j + 2;
                a.fromArray(position.data, ai * stride);
                b.fromArray(position.data, bi * stride);
                c.fromArray(position.data, ci * stride);
                const distance = this.intersectTriangle(a, b, c, cullFace, origin, direction, faceNormal);
                if (!distance) continue;
                // Too far away
                if (maxDistance && distance > localMaxDistance) continue;
                if (!localDistance || distance < localDistance) {
                    localDistance = distance;
                    closestA = ai;
                    closestB = bi;
                    closestC = ci;
                    closestFaceNormal.copy(faceNormal);
                }
            }
            if (!localDistance) hits.splice(i, 1);
            // Update hit values from bounds-test
            mesh.hit.localPoint.copy(direction).multiply(localDistance).add(origin);
            mesh.hit.point.copy(mesh.hit.localPoint).applyMatrix4(mesh.worldMatrix);
            mesh.hit.distance = mesh.hit.point.distance(this.origin);
            // Add unique hit objects on mesh to avoid generating lots of objects
            if (!mesh.hit.faceNormal) {
                mesh.hit.localFaceNormal = new (0, $46d76f993ed555f5$export$838423f3adec30fa)();
                mesh.hit.faceNormal = new (0, $46d76f993ed555f5$export$838423f3adec30fa)();
                mesh.hit.uv = new (0, $fa4ed4f88e886272$export$ac4bca90992eed1)();
                mesh.hit.localNormal = new (0, $46d76f993ed555f5$export$838423f3adec30fa)();
                mesh.hit.normal = new (0, $46d76f993ed555f5$export$838423f3adec30fa)();
            }
            // Add face normal data which is already computed
            mesh.hit.localFaceNormal.copy(closestFaceNormal);
            mesh.hit.faceNormal.copy(mesh.hit.localFaceNormal).transformDirection(mesh.worldMatrix);
            // Optional data, opt out to optimise a bit if necessary
            if (includeUV || includeNormal) {
                // Calculate barycoords to find uv values at hit point
                a.fromArray(position.data, closestA * 3);
                b.fromArray(position.data, closestB * 3);
                c.fromArray(position.data, closestC * 3);
                this.getBarycoord(mesh.hit.localPoint, a, b, c, barycoord);
            }
            if (includeUV && attributes.uv) {
                uvA.fromArray(attributes.uv.data, closestA * 2);
                uvB.fromArray(attributes.uv.data, closestB * 2);
                uvC.fromArray(attributes.uv.data, closestC * 2);
                mesh.hit.uv.set(uvA.x * barycoord.x + uvB.x * barycoord.y + uvC.x * barycoord.z, uvA.y * barycoord.x + uvB.y * barycoord.y + uvC.y * barycoord.z);
            }
            if (includeNormal && attributes.normal) {
                a.fromArray(attributes.normal.data, closestA * 3);
                b.fromArray(attributes.normal.data, closestB * 3);
                c.fromArray(attributes.normal.data, closestC * 3);
                mesh.hit.localNormal.set(a.x * barycoord.x + b.x * barycoord.y + c.x * barycoord.z, a.y * barycoord.x + b.y * barycoord.y + c.y * barycoord.z, a.z * barycoord.x + b.z * barycoord.y + c.z * barycoord.z);
                mesh.hit.normal.copy(mesh.hit.localNormal).transformDirection(mesh.worldMatrix);
            }
        }
        hits.sort((a, b)=>a.hit.distance - b.hit.distance);
        return hits;
    }
    intersectPlane(plane, origin = this.origin, direction = this.direction) {
        const xminp = $7e9178712a9372f4$var$tempVec3a;
        xminp.sub(plane.origin, origin);
        const a = xminp.dot(plane.normal);
        const b = direction.dot(plane.normal);
        // Assuming we don't want to count a ray parallel to the plane as intersecting
        if (b == 0) return 0;
        const delta = a / b;
        if (delta <= 0) return 0;
        return origin.add(direction.scale(delta));
    }
    intersectSphere(sphere, origin = this.origin, direction = this.direction) {
        const ray = $7e9178712a9372f4$var$tempVec3c;
        ray.sub(sphere.center, origin);
        const tca = ray.dot(direction);
        const d2 = ray.dot(ray) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return 0;
        const thc = Math.sqrt(radius2 - d2);
        const t0 = tca - thc;
        const t1 = tca + thc;
        if (t0 < 0 && t1 < 0) return 0;
        if (t0 < 0) return t1;
        return t0;
    }
    // Ray AABB - Ray Axis aligned bounding box testing
    intersectBox(box, origin = this.origin, direction = this.direction) {
        let tmin, tmax, tYmin, tYmax, tZmin, tZmax;
        const invdirx = 1 / direction.x;
        const invdiry = 1 / direction.y;
        const invdirz = 1 / direction.z;
        const min = box.min;
        const max = box.max;
        tmin = ((invdirx >= 0 ? min.x : max.x) - origin.x) * invdirx;
        tmax = ((invdirx >= 0 ? max.x : min.x) - origin.x) * invdirx;
        tYmin = ((invdiry >= 0 ? min.y : max.y) - origin.y) * invdiry;
        tYmax = ((invdiry >= 0 ? max.y : min.y) - origin.y) * invdiry;
        if (tmin > tYmax || tYmin > tmax) return 0;
        if (tYmin > tmin) tmin = tYmin;
        if (tYmax < tmax) tmax = tYmax;
        tZmin = ((invdirz >= 0 ? min.z : max.z) - origin.z) * invdirz;
        tZmax = ((invdirz >= 0 ? max.z : min.z) - origin.z) * invdirz;
        if (tmin > tZmax || tZmin > tmax) return 0;
        if (tZmin > tmin) tmin = tZmin;
        if (tZmax < tmax) tmax = tZmax;
        if (tmax < 0) return 0;
        return tmin >= 0 ? tmin : tmax;
    }
    intersectTriangle(a, b, c, backfaceCulling = true, origin = this.origin, direction = this.direction, normal = $7e9178712a9372f4$var$tempVec3g) {
        // from https://github.com/mrdoob/three.js/blob/master/src/math/Ray.js
        // which is from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        const edge1 = $7e9178712a9372f4$var$tempVec3h;
        const edge2 = $7e9178712a9372f4$var$tempVec3i;
        const diff = $7e9178712a9372f4$var$tempVec3j;
        edge1.sub(b, a);
        edge2.sub(c, a);
        normal.cross(edge1, edge2);
        let DdN = direction.dot(normal);
        if (!DdN) return 0;
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return 0;
            sign = 1;
        } else {
            sign = -1;
            DdN = -DdN;
        }
        diff.sub(origin, a);
        let DdQxE2 = sign * direction.dot(edge2.cross(diff, edge2));
        if (DdQxE2 < 0) return 0;
        let DdE1xQ = sign * direction.dot(edge1.cross(diff));
        if (DdE1xQ < 0) return 0;
        if (DdQxE2 + DdE1xQ > DdN) return 0;
        let QdN = -sign * diff.dot(normal);
        if (QdN < 0) return 0;
        return QdN / DdN;
    }
    getBarycoord(point, a, b, c, target = $7e9178712a9372f4$var$tempVec3h) {
        // From https://github.com/mrdoob/three.js/blob/master/src/math/Triangle.js
        // static/instance method to calculate barycentric coordinates
        // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
        const v0 = $7e9178712a9372f4$var$tempVec3i;
        const v1 = $7e9178712a9372f4$var$tempVec3j;
        const v2 = $7e9178712a9372f4$var$tempVec3k;
        v0.sub(c, a);
        v1.sub(b, a);
        v2.sub(point, a);
        const dot00 = v0.dot(v0);
        const dot01 = v0.dot(v1);
        const dot02 = v0.dot(v2);
        const dot11 = v1.dot(v1);
        const dot12 = v1.dot(v2);
        const denom = dot00 * dot11 - dot01 * dot01;
        if (denom === 0) return target.set(-2, -1, -1);
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        return target.set(1 - u - v, v, u);
    }
}

// TODO: delete texture
// TODO: use texSubImage2D for updates (video or when loaded)
// TODO: need? encoding = linearEncoding
// TODO: support non-compressed mipmaps uploads
const $05f54be274ae4953$var$emptyPixel = new Uint8Array(4);
function $05f54be274ae4953$var$isPowerOf2(value) {
    return (value & value - 1) === 0;
}
let $05f54be274ae4953$var$ID = 1;
class $05f54be274ae4953$export$5431306cf43de24a {
    constructor(gl, { image: image, target: target = gl.TEXTURE_2D, type: type = gl.UNSIGNED_BYTE, format: format = gl.RGBA, internalFormat: internalFormat = format, wrapS: wrapS = gl.CLAMP_TO_EDGE, wrapT: wrapT = gl.CLAMP_TO_EDGE, generateMipmaps: generateMipmaps = true, minFilter: minFilter = generateMipmaps ? gl.NEAREST_MIPMAP_LINEAR : gl.LINEAR, magFilter: magFilter = gl.LINEAR, premultiplyAlpha: premultiplyAlpha = false, unpackAlignment: unpackAlignment = 4, flipY: flipY = target == gl.TEXTURE_2D ? true : false, anisotropy: anisotropy = 0, level: level = 0, width: width, height: height = width } = {}){
        this.gl = gl;
        this.id = $05f54be274ae4953$var$ID++;
        this.image = image;
        this.target = target;
        this.type = type;
        this.format = format;
        this.internalFormat = internalFormat;
        this.minFilter = minFilter;
        this.magFilter = magFilter;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.generateMipmaps = generateMipmaps;
        this.premultiplyAlpha = premultiplyAlpha;
        this.unpackAlignment = unpackAlignment;
        this.flipY = flipY;
        this.anisotropy = Math.min(anisotropy, this.gl.renderer.parameters.maxAnisotropy);
        this.level = level;
        this.width = width;
        this.height = height;
        this.texture = this.gl.createTexture();
        this.store = {
            image: null
        };
        // Alias for state store to avoid redundant calls for global state
        this.glState = this.gl.renderer.state;
        // State store to avoid redundant calls for per-texture state
        this.state = {};
        this.state.minFilter = this.gl.NEAREST_MIPMAP_LINEAR;
        this.state.magFilter = this.gl.LINEAR;
        this.state.wrapS = this.gl.REPEAT;
        this.state.wrapT = this.gl.REPEAT;
        this.state.anisotropy = 0;
    }
    bind() {
        // Already bound to active texture unit
        if (this.glState.textureUnits[this.glState.activeTextureUnit] === this.id) return;
        this.gl.bindTexture(this.target, this.texture);
        this.glState.textureUnits[this.glState.activeTextureUnit] = this.id;
    }
    update(textureUnit = 0) {
        const needsUpdate = !(this.image === this.store.image && !this.needsUpdate);
        // Make sure that texture is bound to its texture unit
        if (needsUpdate || this.glState.textureUnits[textureUnit] !== this.id) {
            // set active texture unit to perform texture functions
            this.gl.renderer.activeTexture(textureUnit);
            this.bind();
        }
        if (!needsUpdate) return;
        this.needsUpdate = false;
        if (this.flipY !== this.glState.flipY) {
            this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, this.flipY);
            this.glState.flipY = this.flipY;
        }
        if (this.premultiplyAlpha !== this.glState.premultiplyAlpha) {
            this.gl.pixelStorei(this.gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this.premultiplyAlpha);
            this.glState.premultiplyAlpha = this.premultiplyAlpha;
        }
        if (this.unpackAlignment !== this.glState.unpackAlignment) {
            this.gl.pixelStorei(this.gl.UNPACK_ALIGNMENT, this.unpackAlignment);
            this.glState.unpackAlignment = this.unpackAlignment;
        }
        if (this.minFilter !== this.state.minFilter) {
            this.gl.texParameteri(this.target, this.gl.TEXTURE_MIN_FILTER, this.minFilter);
            this.state.minFilter = this.minFilter;
        }
        if (this.magFilter !== this.state.magFilter) {
            this.gl.texParameteri(this.target, this.gl.TEXTURE_MAG_FILTER, this.magFilter);
            this.state.magFilter = this.magFilter;
        }
        if (this.wrapS !== this.state.wrapS) {
            this.gl.texParameteri(this.target, this.gl.TEXTURE_WRAP_S, this.wrapS);
            this.state.wrapS = this.wrapS;
        }
        if (this.wrapT !== this.state.wrapT) {
            this.gl.texParameteri(this.target, this.gl.TEXTURE_WRAP_T, this.wrapT);
            this.state.wrapT = this.wrapT;
        }
        if (this.anisotropy && this.anisotropy !== this.state.anisotropy) {
            this.gl.texParameterf(this.target, this.gl.renderer.getExtension("EXT_texture_filter_anisotropic").TEXTURE_MAX_ANISOTROPY_EXT, this.anisotropy);
            this.state.anisotropy = this.anisotropy;
        }
        if (this.image) {
            if (this.image.width) {
                this.width = this.image.width;
                this.height = this.image.height;
            }
            if (this.target === this.gl.TEXTURE_CUBE_MAP) // For cube maps
            for(let i = 0; i < 6; i++)this.gl.texImage2D(this.gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, this.level, this.internalFormat, this.format, this.type, this.image[i]);
            else if (ArrayBuffer.isView(this.image)) // Data texture
            this.gl.texImage2D(this.target, this.level, this.internalFormat, this.width, this.height, 0, this.format, this.type, this.image);
            else if (this.image.isCompressedTexture) // Compressed texture
            for(let level = 0; level < this.image.length; level++)this.gl.compressedTexImage2D(this.target, level, this.internalFormat, this.image[level].width, this.image[level].height, 0, this.image[level].data);
            else // Regular texture
            this.gl.texImage2D(this.target, this.level, this.internalFormat, this.format, this.type, this.image);
            if (this.generateMipmaps) {
                // For WebGL1, if not a power of 2, turn off mips, set wrapping to clamp to edge and minFilter to linear
                if (!this.gl.renderer.isWebgl2 && (!$05f54be274ae4953$var$isPowerOf2(this.image.width) || !$05f54be274ae4953$var$isPowerOf2(this.image.height))) {
                    this.generateMipmaps = false;
                    this.wrapS = this.wrapT = this.gl.CLAMP_TO_EDGE;
                    this.minFilter = this.gl.LINEAR;
                } else this.gl.generateMipmap(this.target);
            }
            // Callback for when data is pushed to GPU
            this.onUpdate && this.onUpdate();
        } else {
            if (this.target === this.gl.TEXTURE_CUBE_MAP) // Upload empty pixel for each side while no image to avoid errors while image or video loading
            for(let i = 0; i < 6; i++)this.gl.texImage2D(this.gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, this.gl.RGBA, 1, 1, 0, this.gl.RGBA, this.gl.UNSIGNED_BYTE, $05f54be274ae4953$var$emptyPixel);
            else if (this.width) // image intentionally left null for RenderTarget
            this.gl.texImage2D(this.target, this.level, this.internalFormat, this.width, this.height, 0, this.format, this.type, null);
            else // Upload empty pixel if no image to avoid errors while image or video loading
            this.gl.texImage2D(this.target, 0, this.gl.RGBA, 1, 1, 0, this.gl.RGBA, this.gl.UNSIGNED_BYTE, $05f54be274ae4953$var$emptyPixel);
        }
        this.store.image = this.image;
    }
}


var $111d60cbbc9fc430$exports = {};
$111d60cbbc9fc430$exports = "precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec2 uv;\n\nuniform vec2 uMouse;\nuniform float uTime;\n\nuniform mat4 modelViewMatrix;\nuniform mat4 projectionMatrix;\n\nvarying vec2 vUv;\n\nvoid main() {\n    vUv = uv;\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n}\n";


var $abac0e9c344fe2f6$exports = {};
$abac0e9c344fe2f6$exports = "precision mediump float;\n#define GLSLIFY 1\n\nuniform float uTime;\nuniform vec2 uMouse;\nuniform sampler2D uBaseTexture;\nuniform sampler2D uBlurTexture;\n\nuniform vec2 uHitUV;\n\nuniform float uFocusSize;\nuniform float uStrength;\n\nuniform vec2 uFocusUV;\nuniform vec2 uMaskUV;\nuniform float uTransitionProgress;\n\nuniform float uAspect;\nuniform vec3 uAccentColor;\n\nvarying vec2 vUv;\n\nfloat sdfCircle(vec2 st, vec2 center) {\n    return length(st - center) * 2.0;\n}\n\nvoid main() {\n    vec2 uv = vUv;\n\n    // float focusSize = 1.4;\n    float focusSize = uFocusSize;\n    float sdfOutput = 1.0 - smoothstep(0.1, 0.9, 1.0 - sdfCircle(uv / focusSize, uFocusUV / focusSize));\n\n    float time = (1.0 + sin(uTime * .0005)) * 0.5;\n\n    float maskSize = uTransitionProgress * 4.5;\n    float sdfOutputBig = 1.0 - smoothstep(0.0, 1.0, 1.0 - sdfCircle(uv / maskSize, uMaskUV / maskSize));\n\n    vec4 baseTextureColor = texture2D(uBaseTexture, uv);\n    vec4 blurTextureColor = texture2D(uBlurTexture, uv);\n    // vec4 blendedEdge = smoothstep(0.4, 0.9, blurTextureColor + sdfOutput);\n    // vec4 blendedEdge = baseTextureColor * smoothstep(0.2, 0.9, blurTextureColor + sdfOutput);\n\n    float strengh = 1.0 - min(uStrength, 0.4);\n    float threshold = 0.92;\n\n    vec4 blendedEdge = smoothstep(threshold - strengh, threshold, smoothstep(threshold - strengh, threshold, blurTextureColor + sdfOutput));\n    vec4 accentColor = vec4(uAccentColor, baseTextureColor.a);\n    vec4 blendedEdgeColor = vec4(vec3(accentColor.rgb), 1.0 - blendedEdge.r);\n\n    float smoothedBigCircle = smoothstep(.4, .8, .1 + sdfOutputBig - 0.1);\n    vec4 baseTextureWithMask = mix(baseTextureColor, vec4(vec3(1.0), 0.0), smoothedBigCircle * blurTextureColor.r);\n\n    // gl_FragColor = baseTextureWithMask;\n\n    gl_FragColor = mix(baseTextureWithMask, blendedEdgeColor, blendedEdgeColor.a) * vec4(1.0, 1.0, 1.0, uTransitionProgress);\n\n    // gl_FragColor = baseTextureColor;\n    // gl_FragColor = vec4(sin(uMouse * 0.001));\n}\n";



class $e047d80b1b3f090b$export$1e232f3e03aec419 {
    constructor(){
        this.movmentRecordCount = 3;
        this.movements = [];
        for(let i = 0; i < this.movmentRecordCount; i++)this.movements.push(new (0, $fa4ed4f88e886272$export$ac4bca90992eed1)());
    }
    /**
   * Observe movement
   * @param position : ;
   */ recordMovement(position) {
        // remove the last one
        this.movements.splice(this.movements.length - 1, 1);
        // insert to the beginning
        this.movements.unshift(new (0, $fa4ed4f88e886272$export$ac4bca90992eed1)(position.x, position.y));
    }
    /**
   * Get the max Velocity
   * @returns
   */ getMaxVelocity() {
        let maxVelX = 0;
        let maxVelY = 0;
        for(let i = 0; i < this.movmentRecordCount; i++){
            const velX = this.movements[i].x;
            const velY = this.movements[i].y;
            maxVelX = Math.abs(velX) > Math.abs(maxVelX) ? velX : maxVelX;
            maxVelY = Math.abs(velY) > Math.abs(maxVelY) ? velY : maxVelY;
        }
        return new (0, $fa4ed4f88e886272$export$ac4bca90992eed1)(maxVelX, maxVelY);
    }
    getAverageVelocity() {
        let totalVelX = 0;
        let totalVelY = 0;
        for(let i = 1; i < this.movmentRecordCount; i++){
            const velX = this.movements[i].x - this.movements[i - 1].x;
            const velY = this.movements[i].y - this.movements[i - 1].y;
            totalVelX += velX;
            totalVelY += velY;
        }
        const averageVelX = totalVelX / (this.movmentRecordCount - 1);
        const averageVelY = totalVelY / (this.movmentRecordCount - 1);
        return new (0, $fa4ed4f88e886272$export$ac4bca90992eed1)(averageVelX, averageVelY);
    }
}


function $df5bef30413a053b$export$3a89f8d6f6bf6c9f(target, current, lerp = 0.05) {
    return current - (current - target) * lerp;
}
function $df5bef30413a053b$export$e1cbde30980fd3be(target, position, lerp = 0.05) {
    position.x = position.x - (position.x - target.x) * lerp;
    position.y = position.y - (position.y - target.y) * lerp;
}


class $2c40f96f9823cb86$export$9eab9f8785d17378 {
    constructor(gl, { close: close, blur: blur, mouse: mouse, scene: scene, camera: camera, scale: scale = 1, offset: offset = new (0, $46d76f993ed555f5$export$838423f3adec30fa)() }){
        this.mouseVelObserver = new (0, $e047d80b1b3f090b$export$1e232f3e03aec419)();
        this.mouseTargetUV = new (0, $fa4ed4f88e886272$export$ac4bca90992eed1)();
        this.mouse = mouse;
        this.camera = camera;
        this.offset = offset;
        const geometry = new (0, $733fd634af54059e$export$7ff5ac152ef991b0)(gl, {
            widthSegments: 1,
            heightSegments: 1,
            width: 1 * scale,
            height: close.height / close.width * scale
        });
        const gardenCloseTexture = new (0, $05f54be274ae4953$export$5431306cf43de24a)(gl, {
            image: close
        });
        const gardenCloseBlurTexture = new (0, $05f54be274ae4953$export$5431306cf43de24a)(gl, {
            image: blur
        });
        const program = new (0, $5baeac5adaf115e1$export$b6c59b989905b650)(gl, {
            vertex: (0, (/*@__PURE__*/$parcel$interopDefault($111d60cbbc9fc430$exports))),
            fragment: (0, (/*@__PURE__*/$parcel$interopDefault($abac0e9c344fe2f6$exports))),
            uniforms: {
                uTime: {
                    value: 0
                },
                uMouse: {
                    value: mouse
                },
                uBlurTexture: {
                    value: gardenCloseBlurTexture
                },
                uBaseTexture: {
                    value: gardenCloseTexture
                },
                uAspect: {
                    value: gl.canvas.width / gl.canvas.height
                },
                uHitUV: {
                    value: new (0, $fa4ed4f88e886272$export$ac4bca90992eed1)()
                },
                uFocusUV: {
                    value: new (0, $fa4ed4f88e886272$export$ac4bca90992eed1)()
                },
                uMaskUV: {
                    value: new (0, $fa4ed4f88e886272$export$ac4bca90992eed1)()
                },
                uFocusSize: {
                    value: 0
                },
                uStrength: {
                    value: 0
                },
                uAccentColor: {
                    value: new (0, $46d76f993ed555f5$export$838423f3adec30fa)(0.3, 0.3, 0.3)
                },
                uTransitionProgress: {
                    value: 0
                }
            },
            transparent: true
        });
        this.program = program;
        const mesh = new (0, $81280ac60efc3984$export$e176487c05830cc5)(gl, {
            geometry: geometry,
            program: program
        });
        mesh.position.add(offset);
        this.mesh = mesh;
        mesh.setParent(scene);
        // mouse raycast
        this.raycast = new (0, $7e9178712a9372f4$export$ff2d1de6a335cd2e)();
    }
    update(gl, time, transitionProgress) {
        const program = this.program;
        const mesh = this.mesh;
        // perform mouse ray casting
        this.raycast.castMouse(this.camera, this.mouse);
        const hit = this.raycast.intersectMeshes([
            mesh
        ]);
        hit.forEach((mesh)=>{
            // mesh.program.uniforms.uHitUV.value = mesh.hit.uv;
            this.mouseTargetUV = mesh.hit.uv;
        });
        // update interaction logic
        const mouseSpeed = this.mouseVelObserver.getAverageVelocity().len();
        this.mouseVelObserver.recordMovement(mesh.program.uniforms.uFocusUV.value);
        // lerpVec(this.mouseTargetUV, mesh.program.uniforms.uMaskUV.value, 0.007);
        mesh.program.uniforms.uMaskUV.value = this.offset;
        (0, $df5bef30413a053b$export$e1cbde30980fd3be)(this.mouseTargetUV, mesh.program.uniforms.uFocusUV.value, 0.1);
        // update logic
        program.uniforms.uTime.value = time;
        program.uniforms.uAspect.value = gl.canvas.width / gl.canvas.height;
        program.uniforms.uTransitionProgress.value = transitionProgress;
        const maxRot = 0.05;
        // mesh.rotation.y = lerp(
        //   -maxRot - this.mouseTargetUV.x * -maxRot * 2,
        //   mesh.rotation.y,
        //   0.01,
        // );
        // mesh.rotation.x = lerp(
        //   maxRot - focusPositionTargetUV.y * maxRot * 2,
        //   mesh.rotation.x,
        //   0.01,
        // );
        mesh.program.uniforms.uFocusSize.value = mouseSpeed * 30 + 0.5;
        mesh.program.uniforms.uStrength.value = mouseSpeed * 20 + 0.5;
    }
}



var $3bd2f8ffaee40dac$exports = {};
$3bd2f8ffaee40dac$exports = "precision mediump float;\n#define GLSLIFY 1\n\nvarying vec2 vUv;\n\nuniform float uTime;\nuniform sampler2D uTexture;\n\nvoid main() {\n    vec2 uv = vUv;\n    // float time = mod(uTime * 0.000005, 1.0);\n    vec4 color = texture2D(uTexture, fract(uv * 2.0 + uTime));\n\n    float cloudColor = 1.0 - color.r * 2.0;\n    color = vec4(vec3(0.94), smoothstep(0.5, 1.0, color.r));\n\n    gl_FragColor = color;\n}\n";


var $6ed3516daf1c2e7a$exports = {};
$6ed3516daf1c2e7a$exports = "precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec2 uv;\n\nuniform mat4 modelViewMatrix;\nuniform mat4 projectionMatrix;\n\nvarying vec2 vUv;\n\nvoid main() {\n    vUv = uv;\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n}\n";


class $49cd3ddcf46f2e40$export$517de9992f3047ca {
    constructor(gl, { scene: scene, z: z = 1, cloudImage: cloudImage }){
        this.uTime = {
            value: 0
        };
        const texture = new (0, $05f54be274ae4953$export$5431306cf43de24a)(gl, {
            wrapS: gl.REPEAT,
            wrapT: gl.REPEAT,
            image: cloudImage
        });
        const geometry = new (0, $733fd634af54059e$export$7ff5ac152ef991b0)(gl, {
            width: 2,
            height: 2
        });
        const program = new (0, $5baeac5adaf115e1$export$b6c59b989905b650)(gl, {
            vertex: (0, (/*@__PURE__*/$parcel$interopDefault($6ed3516daf1c2e7a$exports))),
            fragment: (0, (/*@__PURE__*/$parcel$interopDefault($3bd2f8ffaee40dac$exports))),
            uniforms: {
                uTime: this.uTime,
                uTexture: {
                    value: texture
                }
            },
            transparent: true
        });
        const mesh = new (0, $81280ac60efc3984$export$e176487c05830cc5)(gl, {
            geometry: geometry,
            program: program
        });
        mesh.position.z = z;
        scene.addChild(mesh);
    }
    update(gl, time) {
        this.uTime.value = time * 0.000005;
    }
}


const $f43313d21d3fd8e2$var$renderer = new (0, $b5a73110aaf50409$export$88530751e3977073)();
const $f43313d21d3fd8e2$var$gl = $f43313d21d3fd8e2$var$renderer.gl;
document.body.appendChild($f43313d21d3fd8e2$var$gl.canvas);
const $f43313d21d3fd8e2$var$camera = new (0, $0725581459e32093$export$79f141de891a5fed)($f43313d21d3fd8e2$var$gl);
$f43313d21d3fd8e2$var$camera.position.z = 1;
// ==================================================
// Canvas resize
// ==================================================
function $f43313d21d3fd8e2$var$resize() {
    $f43313d21d3fd8e2$var$renderer.dpr = window.devicePixelRatio;
    $f43313d21d3fd8e2$var$renderer.setSize(window.innerWidth, window.innerHeight);
    $f43313d21d3fd8e2$var$camera.perspective({
        aspect: $f43313d21d3fd8e2$var$gl.canvas.width / $f43313d21d3fd8e2$var$gl.canvas.height
    });
}
window.addEventListener("resize", $f43313d21d3fd8e2$var$resize, false);
$f43313d21d3fd8e2$var$resize();
// ==================================================
const $f43313d21d3fd8e2$var$mouse = new (0, $fa4ed4f88e886272$export$ac4bca90992eed1)();
const $f43313d21d3fd8e2$var$handleMouseMove = (event)=>{
    event.preventDefault();
    $f43313d21d3fd8e2$var$mouse.x = event.clientX / window.innerWidth * 2 - 1;
    $f43313d21d3fd8e2$var$mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
};
window.addEventListener("pointermove", $f43313d21d3fd8e2$var$handleMouseMove);
var $10adeb9d785addc9$exports = {};
$10adeb9d785addc9$exports = new URL("garden-close.672201a5.png", import.meta.url).toString();


var $fa7864e3e8e6af3b$exports = {};
$fa7864e3e8e6af3b$exports = new URL("garden-close-blur.b00232cf.png", import.meta.url).toString();


var $4e410b5c1cf92fc3$exports = {};
$4e410b5c1cf92fc3$exports = new URL("garden-far.8d0a3065.png", import.meta.url).toString();


var $1fb959ceab75f381$exports = {};
$1fb959ceab75f381$exports = new URL("garden-far-blur.9921d365.png", import.meta.url).toString();


var $046c12dd1500db1d$exports = {};
$046c12dd1500db1d$exports = new URL("cloud.a7c89d94.png", import.meta.url).toString();


(0, $b97a95975d4239c9$export$8657d32331889d65)({
    gardenClose: new URL($10adeb9d785addc9$exports),
    gardenCloseBlur: new URL($fa7864e3e8e6af3b$exports),
    gardenFar: new URL($4e410b5c1cf92fc3$exports),
    gardenFarBlur: new URL($1fb959ceab75f381$exports),
    cloudImage: new URL($046c12dd1500db1d$exports)
}).then((assets)=>{
    const scene = new (0, $b99754c4edbe0b63$export$563a914cafbdc389)();
    // orbit
    // const orbit = new Orbit(camera);
    let isViewingClose = true;
    const CAMERA_CLOSE_Z = 1;
    const CAMERA_FAR_Z = 2;
    const CAMERA_FAR_Y = 0.24;
    const CAMERA_CLOSE_Y = 0;
    const CAMERA_FAR_X = 0;
    const CAMERA_CLOSE_X = 0;
    const targetCameraPos = new (0, $46d76f993ed555f5$export$838423f3adec30fa)();
    window.addEventListener("click", ()=>{
        isViewingClose = !isViewingClose;
    });
    const gardenSmall = new (0, $2c40f96f9823cb86$export$9eab9f8785d17378)($f43313d21d3fd8e2$var$gl, {
        close: assets.gardenClose,
        blur: assets.gardenCloseBlur,
        scale: 1,
        mouse: $f43313d21d3fd8e2$var$mouse,
        scene: scene,
        camera: $f43313d21d3fd8e2$var$camera
    });
    const gardenFar = new (0, $2c40f96f9823cb86$export$9eab9f8785d17378)($f43313d21d3fd8e2$var$gl, {
        close: assets.gardenFar,
        blur: assets.gardenFarBlur,
        scale: 1.79,
        offset: new (0, $46d76f993ed555f5$export$838423f3adec30fa)(0.069, 0.317, 0.01),
        mouse: $f43313d21d3fd8e2$var$mouse,
        scene: scene,
        camera: $f43313d21d3fd8e2$var$camera
    });
    const cloudsLayer1 = new (0, $49cd3ddcf46f2e40$export$517de9992f3047ca)($f43313d21d3fd8e2$var$gl, {
        scene: scene,
        cloudImage: assets.cloudImage
    });
    const cloudsLayer2 = new (0, $49cd3ddcf46f2e40$export$517de9992f3047ca)($f43313d21d3fd8e2$var$gl, {
        scene: scene,
        cloudImage: assets.cloudImage,
        z: 1.4
    });
    function update(time) {
        $f43313d21d3fd8e2$var$renderer.gl.clearColor(254 / 255, 1, 250 / 255, 1.0);
        targetCameraPos.z = isViewingClose ? CAMERA_CLOSE_Z : CAMERA_FAR_Z;
        targetCameraPos.x = isViewingClose ? CAMERA_CLOSE_X : CAMERA_FAR_X;
        targetCameraPos.y = isViewingClose ? CAMERA_CLOSE_Y : CAMERA_FAR_Y;
        const withMouseParallaxOffset = new (0, $46d76f993ed555f5$export$838423f3adec30fa)().copy(targetCameraPos);
        const mouseOffsetFactor = isViewingClose ? 0.01 : 0.2;
        const mouseOffsetAmount = new (0, $46d76f993ed555f5$export$838423f3adec30fa)($f43313d21d3fd8e2$var$mouse.x * mouseOffsetFactor, $f43313d21d3fd8e2$var$mouse.y * mouseOffsetFactor, 0);
        withMouseParallaxOffset.add(mouseOffsetAmount);
        $f43313d21d3fd8e2$var$camera.position.lerp(targetCameraPos, 0.05);
        $f43313d21d3fd8e2$var$camera.position.lerp(withMouseParallaxOffset, 0.01);
        $f43313d21d3fd8e2$var$camera.rotation = new (0, $5f514479e80f605c$export$d93cc409a0768c5f)().fromRotationMatrix(new (0, $4e21c701cd686be1$export$21c0e3d5e995d7e1)().lookAt($f43313d21d3fd8e2$var$camera.position, new (0, $46d76f993ed555f5$export$838423f3adec30fa)(0, 0, 0), new (0, $46d76f993ed555f5$export$838423f3adec30fa)(0, 1, 0)));
        console.clear();
        console.log($f43313d21d3fd8e2$var$camera.rotation.x);
        // camera.rotation.y = lerp(
        //   mouseOffsetFactor * mouse.x * 0.2,
        //   camera.rotation.y,
        //   0.1,
        // );
        // orbit.update();
        const transitionProgress = ($f43313d21d3fd8e2$var$camera.position.z - CAMERA_CLOSE_Z) / (CAMERA_FAR_Z - CAMERA_CLOSE_Z);
        gardenSmall.update($f43313d21d3fd8e2$var$gl, time, 1 - transitionProgress);
        gardenFar.update($f43313d21d3fd8e2$var$gl, time, transitionProgress);
        cloudsLayer1.update($f43313d21d3fd8e2$var$gl, time);
        cloudsLayer2.update($f43313d21d3fd8e2$var$gl, time);
        // render to screen
        $f43313d21d3fd8e2$var$renderer.render({
            scene: scene,
            camera: $f43313d21d3fd8e2$var$camera
        });
        requestAnimationFrame(update);
    }
    requestAnimationFrame(update);
});


//# sourceMappingURL=index.a800e923.js.map
